import { Component, DoCheck, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { applyDocumentCoordinatesToLines, CorrectionIntent, deriveRowBox, expandRowBoxesToMidpoints, IDocumentCoordinatesResponse, IExtractedNote, IFieldLocations, IIgnoreUnmatchedItem, IMatchUnmatchedItem, IParseProduct, IQuotationDetail, IQuotationSourceContent, ISourceLocation, ISourceLocationCell, IUpdateQuotationDetails, PriceSourceType, SourceLocationField, withFallbackAttachments } from '../../models/quotations.models';
import { attachmentFileName, attachmentPathKey, findSourceAttachment, IOrderSourceLine, preferredPreviewAttachment, sourceNamesAttachment } from '../../utils/order-source-attachment.util';
import { roundPrice } from '../../utils/price-decimals.util';
import { DocumentCellHighlight, DocumentCellRegion, DocumentHighlight, DocumentLineRegion } from 'src/app/shared/files-previewer/files-previewer.component';
import { decodeRowSpan } from 'src/app/shared/files-previewer/sheet-range.util';
import { HighlightBox } from 'src/app/shared/files-previewer/document-highlight-layer/document-highlight-layer.component';
import { CompanyLocationResult } from 'src/app/features/new-orders/components/company-location-selector/company-location-selector.component';
import { ICustomer, ILocation, IPayment_term } from 'src/app/features/customers/models/customers.models';
import { DATE_FORMAT, DEFAULT_LINES_PAGE_SIZE } from 'src/app/config/global.config';
import { trigger } from '@angular/animations';
import { state } from '@angular/animations';
import { style } from '@angular/animations';
import { transition } from '@angular/animations';
import { animate } from '@angular/animations';
import { ProductNotesDialogComponent, IProductNotesDialogResult } from '../product-notes-dialog/product-notes-dialog.component';
import { EnrichCompanyEmailsDialogComponent, IEnrichCompanyEmailsDeferredResult } from '../enrich-company-emails-dialog/enrich-company-emails-dialog.component';
import { IProduct, IProductHandlingUnit, IProductInventoryDetails } from 'src/app/features/produits/models/products.models';
import { ProductsService } from 'src/app/features/produits/services/produits.services';
import { HandlingUnitsDialogueComponent } from 'src/app/features/produits/components/handling-units-dialogue/handling-units-dialogue.component';
import { applyHandlingUnitRounding, handlingUnitBaseMultiplier, handlingUnitHasConversion, quantityInBaseUnitsTranslationParams } from 'src/app/shared/utils/handling-unit.utils';
import { MatSelectChange } from '@angular/material/select';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { environment } from 'src/environments/environment';
import { combineLatest, debounceTime, distinctUntilChanged, filter, finalize, Observable, Subject, switchMap, take, takeUntil } from 'rxjs';
import { FormControl } from '@angular/forms';
import { IOrderUser } from 'src/app/features/orders/models/order.model';
import { OrdersService } from 'src/app/features/orders/services/orders.services';
import { CustomerEmailService } from 'src/app/features/knowledge-base/services/customer-email.service';
import { CommonService } from 'src/app/shared/common.service';
import { QuotesService } from '../../services/quotations.services';
import { PriceCandidatesStore } from '../../services/price-candidates.store';
import { IPriceCandidate, IPricePolicyTrace, orderLineProductId } from '../../models/quotations.models';
import { ISegregationCheck, SegregationPreviewService } from '../../services/segregation-preview.service';
import { IPagination } from 'src/app/shared/models/page.model';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { ClearProducts, FetchProductsBySearch } from 'src/app/features/produits/store/produits.actions';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import {
  AppendQuotationPage,
  DismissDuplicateBadge,
  GetQuotationById,
  GetQuotationByIdError,
  GetQuotationSourceContent,
  GetQuotationSourceContentError,
  DismissSuggestedLocation,
  GetQuotationDocumentCoordinates,
  UpdateQuotationDetails,
  UpdateQuotationDetailsSuccess,
  UpdateQuotationLines,
  UpdateQuotationLinesSuccess,
  UpdateAiNotes,
  validateOrder,
  validateOrderSuccess,
  validateOrderError,
  cancelQuotation,
  cancelQuotationSuccess,
  cancelQuotationError,
  deleteQuotation,
  deleteQuotationSuccess,
  deleteQuotationError,
  DuplicateQuotation,
  ArchiveQuotation,
  ArchiveQuotationSuccess,
  ArchiveQuotationError,
} from 'src/app/features/quotations/store/quotations.actions';
import { OrderStatusDialogService } from '../../services/order-status-dialog.service';
import { QuotationExportService } from '../../services/quotation-export.service';
import { IQuickActionField, QuickActionsPreferencesService } from 'src/app/shared/quick-actions-preferences.service';
import { QuickActionEvent } from './order-quick-actions-row/order-quick-actions-row.component';
import { EmailBodyAnchorRegion, EmailBodyHighlightDirective } from './email-body-highlight.directive';
import { Actions, ofType } from '@ngrx/effects';
import { ICurrency } from 'src/app/features/customers/models/customers.models';
import { ConfirmationPopUpComponent } from 'src/app/shared/confirmation-pop-up/confirmation-pop-up.component';
import { TranslateService } from '@ngx-translate/core';
import { ITableColumnSetting, TablePreferencesService } from 'src/app/shared/table-preferences.service';
import { ISentToErpRespone } from '../../models/quotations.models';
import { IObjectCustomFields, IObjectCustomFieldsParams } from 'src/app/features/settings/models/settings.models';
import { CustomFieldVisibilityTypes, RelatedObjectsTypes } from 'src/app/features/settings/models/custom-fields.constants';
import {
  IProductCustomFieldCell,
  IProductCustomFieldColumn,
  ProductCustomFieldColumnKey,
  ProductCustomFieldColumnsService,
} from '../../services/product-custom-field-columns.service';
import { GetObjectCustomFields, UpdateObjectCustomFields } from 'src/app/features/settings/store/settings.actions';
import { CustomFieldTypes } from 'src/app/features/settings/models/custom-fields.constants';
import { IDetailField, IDetailFieldChange } from 'src/app/ui/detail-field/detail-field.models';
import { IDetailFieldGroup, IDetailFieldGroupChange } from 'src/app/ui/detail-fields-settings/detail-fields-settings.component';
import { OrderDetailFieldsService } from '../../services/order-detail-fields.service';
import { DetailFieldListComponent } from 'src/app/ui/detail-field-list/detail-field-list.component';
import { getUserColor } from 'src/app/shared/utils/user-color.util';
import { ILocationCodeTag, locationCodeTags } from 'src/app/shared/utils/location-codes.util';
import { userInitials } from 'src/app/shared/utils/order-users-dedupe';
import { ISegregationInfo, ISegregationSplit } from '../../models/quotations.models';
import {
  LINKED_ORDERS_INLINE_MAX,
  LinkedOrdersModalComponent,
} from '../linked-orders-modal/linked-orders-modal.component';
import { FetchAllpaymentTerms } from 'src/app/features/customers/store/customers.actions';
import { selectHiddenFieldsForModule } from 'src/app/core/store/field-visibility/field-visibility.selectors';
import { LanguageService } from 'src/app/config/language.service';
import { OrderCustomFieldsComponent } from '../order-custom-fields/order-custom-fields.component';
import { FeatureFlagService } from 'src/app/core/services/feature-flag.service';
import { ProductCodeService } from 'src/app/core/services/product-code.service';
import {
  LineGroupView,
  LineGroupingController,
  LineGroupingMode,
  LineMatchGroup,
} from '../../utils/line-match-group.util';
import { resolveAttentionCount, resolveLineCount } from '../../utils/line-composition.util';

/**
 * Where the panel was opened from. Smart Inbox turns it into a full approval
 * surface (approve as the main action, an overflow menu, the quick-actions row);
 * the order-details page keeps the original save-only behaviour. WB-7478.
 */
export type SideBySidePanelOrigin = 'smart-inbox' | 'order-details';

/**
 * Close results signalling that the panel changed the order server-side, so whoever
 * opened it should refresh what it renders about that order.
 */
export const SIDE_BY_SIDE_RESULT_APPROVED = 'approved';
export const SIDE_BY_SIDE_RESULT_CANCELLED = 'cancelled';
export const SIDE_BY_SIDE_RESULT_ARCHIVED = 'archived';
export const SIDE_BY_SIDE_RESULT_DELETED = 'deleted';
/**
 * WB-7569 — a splitting rule was applied while the panel was open. Unlike the
 * others this is not a status transition: the order keeps its id and status but
 * loses the lines that moved to the sibling orders, so the timeline artifact
 * still has to refetch or it keeps rendering the pre-split product list.
 */
export const SIDE_BY_SIDE_RESULT_SPLIT = 'split';

export type SideBySidePanelResult =
  | typeof SIDE_BY_SIDE_RESULT_APPROVED
  | typeof SIDE_BY_SIDE_RESULT_CANCELLED
  | typeof SIDE_BY_SIDE_RESULT_ARCHIVED
  | typeof SIDE_BY_SIDE_RESULT_DELETED
  | typeof SIDE_BY_SIDE_RESULT_SPLIT;

const MUTATING_RESULTS: readonly unknown[] = [
  SIDE_BY_SIDE_RESULT_APPROVED,
  SIDE_BY_SIDE_RESULT_CANCELLED,
  SIDE_BY_SIDE_RESULT_ARCHIVED,
  SIDE_BY_SIDE_RESULT_DELETED,
  SIDE_BY_SIDE_RESULT_SPLIT,
];

/**
 * True when the panel closed after mutating the order. Openers that render order
 * state (the Smart Inbox timeline and its sidebar) must refetch on these — they read
 * a different store from the one the panel writes to.
 */
export function sideBySideResultMutatedOrder(result: unknown): boolean {
  return MUTATING_RESULTS.includes(result);
}

export interface SideBySideCorrectionPanelData {
  quotationId: number;
  /** Defaults to `order-details` so existing callers are unaffected. */
  origin?: SideBySidePanelOrigin;
}

// Keys are shared verbatim with the order-details lines table (WB-7903) so the
// two views can never drift apart again — same key, same i18n entry under
// `quotations_and_orders.order_line_columns`, same label.
type BaseColumnKey =
  | 'product'
  | 'brand'
  | 'msrp'
  | 'cost'
  | 'unit_price'
  | 'quantity'
  | 'quantity_preferred_selling_unit'
  | 'quantity_units'
  | 'total_amount'
  | 'profit_margin'
  | 'delivery_date'
  | 'stock'
  | 'notes';

/** Hardcoded columns plus the product custom field columns added by WB-7619. */
type ColumnKey = BaseColumnKey | ProductCustomFieldColumnKey;

interface IColumnConfig {
  label: string;
  /** Label shown in the column-visibility picker when it differs from the table header. */
  pickerLabel?: string;
  visible: boolean;
  locked?: boolean;
  /** True when `label` is already a resolved string rather than an i18n key. */
  rawLabel?: boolean;
}


// Must match the slide-in/out animation duration in styles.scss (`slideInFromRight`).
const SIDE_PANEL_ANIMATION_MS = 450;

const SIDE_BY_SIDE_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: ['DD/MM/YY', 'DD/MM/YYYY', 'YYYY-MM-DD'],
  },
  display: {
    dateInput: 'DD/MM/YY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-side-by-side-correction-panel',
  templateUrl: './side-by-side-correction-panel.component.html',
  styleUrls: ['./side-by-side-correction-panel.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: SIDE_BY_SIDE_DATE_FORMATS }],
  animations: [
    trigger('expandCollapse', [
      state('expanded', style({ height: 'calc(100% - 86px)', opacity: 1, padding: '20px' })),
      state(
        'collapsed',
        style({ height: '0px', opacity: 0, overflow: 'hidden', padding: '0px' })
      ),
      transition('expanded <=> collapsed', animate('300ms ease-in-out')),
    ]),
  ],
})
export class SideBySideCorrectionPanelComponent implements OnInit, DoCheck, OnDestroy {

  /**
   * Order-lines figure in the panel header (WB-8066). Reads from the panel's
   * own `quotation`, so the panel, the orders list and the order detail page
   * all quote the same number through the same popover.
   */
  orderLinesCount(): number {
    return resolveLineCount(this.quotation?.line_composition, this.quotation ?? undefined);
  }

  /** Amber badge: needs review + unmatched. 0 hides the badge. */
  attentionCount(): number {
    return resolveAttentionCount(this.quotation?.line_composition);
  }
  private static readonly THIS_TABLE_KEY = 'order_lines_table-side_by_side_panel';

  /** Preference bucket for the quick-actions row (WB-7478). */
  private static readonly QUICK_ACTIONS_KEY = 'side_by_side_panel';

  /**
   * Default quick-actions row layout: Company · Location · Owner · PO. The
   * remaining fields are available but off until the user adds them. Quote and
   * order share one default set for now.
   */
  private static readonly DEFAULT_QUICK_ACTION_FIELDS: IQuickActionField[] = [
    { key: 'company', label: 'quick_actions.fields.company', visible: true },
    { key: 'location', label: 'quick_actions.fields.location', visible: true },
    { key: 'assignee', label: 'quick_actions.fields.assignee', visible: true },
    { key: 'po_number', label: 'quick_actions.fields.po_number', visible: true },
    { key: 'quote_id', label: 'quick_actions.fields.quote_id', visible: false },
    { key: 'shipping_date', label: 'quick_actions.fields.shipping_date', visible: false },
    { key: 'created', label: 'quick_actions.fields.created', visible: false },
    { key: 'order_id', label: 'quick_actions.fields.order_id', visible: false },
  ];

  /** Per-change-detection-pass memo for `isDirty`; see that getter. */
  private dirtyCache: boolean | null = null;

  /**
   * True between dispatching `validateOrder` and its resolution. Guards
   * `onApproveResolved` so a force-send retry (which resolves again) does not
   * re-enter, mirroring the details page's `pendingForceSend`.
   */
  private approveInFlight = false;

  /**
   * Result to close with once the in-flight destructive mutation succeeds. These used
   * to close on dispatch, which raced the opener's refetch: the conversation reload
   * fired ~450ms later could easily beat the server-side change and read stale state.
   */
  private mutationInFlight: SideBySidePanelResult | null = null;

  /** Quick-actions row state, hydrated from preferences in ngOnInit. */
  quickActionsEnabled = false;
  quickActionFields: IQuickActionField[] = [];

  // Column display order (matches the legacy grid template). 'product' is
  // pinned to the front (immovable, nothing before it) and carries the
  // always-visible status/alert icons, so it cannot be hidden.
  private static readonly DEFAULT_ORDER: ColumnKey[] = [
    'product', 'notes', 'brand', 'msrp', 'cost',
    'unit_price', 'quantity', 'quantity_preferred_selling_unit', 'quantity_units',
    'total_amount', 'profit_margin', 'delivery_date', 'stock',
  ];
  private static readonly PINNED_KEYS = new Set<ColumnKey>(['product']);
  private static readonly NON_HIDEABLE_KEYS = new Set<ColumnKey>([
    'product', 'unit_price', 'quantity', 'total_amount',
  ]);
  /** Pricing / metrics columns gated by the company "hide pricing columns" setting. */
  private static readonly PRICING_KEYS = new Set<ColumnKey>([
    'msrp', 'cost', 'unit_price', 'total_amount', 'profit_margin',
  ]);

  /**
   * WB-7903 — column keys renamed to match the order-details lines table.
   * Migrated once per browser so users keep the layout they had chosen.
   */
  private static readonly RENAMED_KEYS: Record<string, string> = {
    product_name: 'product',
    product_brand: 'brand',
    total: 'total_amount',
  };

  /**
   * Company-level default: when true, pricing columns are hidden BY DEFAULT and
   * become hideable (users can still re-enable them per-user — stored
   * preferences win).
   */
  private hidePricingColumns = false;
  private readonly COLUMN_WIDTHS: Partial<Record<ColumnKey, string>> = {
    product: 'minmax(320px, 2.5fr)',
    notes: 'minmax(80px, 0.6fr)',
    brand: 'minmax(180px, 1.3fr)',
    msrp: 'minmax(140px, 1fr)',
    cost: 'minmax(140px, 1fr)',
    unit_price: 'minmax(140px, 1fr)',
    quantity: 'minmax(260px, 1.5fr)',
    quantity_preferred_selling_unit: 'minmax(180px, 1fr)',
    quantity_units: 'minmax(140px, 1fr)',
    total_amount: 'minmax(160px, 1fr)',
    profit_margin: 'minmax(160px, 1fr)',
    delivery_date: 'minmax(150px, 1.3fr)',
    stock: 'minmax(120px, 1fr)',
  };

  /** Columns passed to the <ui-table-column-settings> popover. */
  pickerColumns: ITableColumnSetting[] = [];
  /** Current column order. */
  columnOrder: ColumnKey[] = [];
  /** Memoized 1-based grid `order` per visible column (checkbox cell = 0). */
  private gridOrderIndex: Partial<Record<ColumnKey, number>> = {};

  /**
   * Product custom field columns (WB-7619) — appended after the hardcoded ones,
   * hidden by default, and looked up per cell by column key.
   */
  private customFieldColumns = new Map<ProductCustomFieldColumnKey, IProductCustomFieldColumn>();

  products$: Observable<IProduct[]> = this.store.select((state)=> state.products.productsBySearch);
  leftPanelActiveTab: 'products' | 'details' = 'products';
  rightPanelActiveTab: 'order-source' = 'order-source';
  contentExpanded: boolean = true;
  orderDeliveryDate: string = '';
  DATE_FORMAT = DATE_FORMAT;
  DELIVERY_DATE_FORMAT = DATE_FORMAT;
  quotation: IQuotationDetail | undefined = undefined;

  readonly LINKED_ORDERS_INLINE_MAX = LINKED_ORDERS_INLINE_MAX;

  quotationSourceContent: IQuotationSourceContent | undefined = undefined;
  products: IParseProduct[] = [];
  newProducts: IParseProduct[] = [];
  removedProducts: number[] = [];
  removedUnmatchedOrderLineIds: number[] = [];
  matchUnmatched: IMatchUnmatchedItem[] = [];
  ignoreUnmatched: IIgnoreUnmatchedItem[] = [];
  currentAttachment: any[] = [];
  selectedAttachmentUrl: string = '';
  /** WB-7399: true once the user picked an attachment themselves — auto-selection never overrides that. */
  private userPickedAttachment = false;
  /** WB-7399: true once a resolved source document was previewed; stops a later line page flipping it. */
  private previewMatchLatched = false;
  /** WB-7399: the attachment the lines were parsed from, or '' when unresolved. Drives the overlay guard. */
  private resolvedSourceAttachment = '';
  /** WB-8267: true once the body's open/closed default was applied for the current attachment list. */
  private bodyDefaultApplied = false;
  /**
   * Document Coordinates (WB-4974) — active-line state, shared by both hover directions:
   * `activeLineKey` is the emphasized line (set by a left-row hover OR a doc-hotspot hover) and drives
   * the doc row tier + the left row highlight; `activeField` is set only by a left field-cell hover and
   * drives the doc field tier. All lookups key by `getRowKey()`, never object identity.
   */
  activeLineKey: string | null = null;
  activeField: SourceLocationField | null = null;
  /**
   * WB-7483 — the line whose doc coordinates are PINNED while the inline alternatives selector is
   * open for it. It outranks `activeLineKey` in `previewHighlight` and freezes every hover input
   * (row / field / doc hotspot), so the document keeps showing the product being re-matched until
   * the user applies or cancels. Doc side only: `isRowActive` still keys off `activeLineKey`, so
   * nothing in the left panel changes.
   */
  lockedLineKey: string | null = null;
  /**
   * WB-6815 real coordinates (from GET .../document_coordinates). Held so we can merge them onto the
   * lines whether they arrive before or after `applyQuotationData` builds `products`/`unmatchedProducts`.
   */
  private documentCoordinates: IDocumentCoordinatesResponse | null = null;
  unmatchedProducts: IParseProduct[] = [];
  baseUrl = environment.BASE_URL_API;
  placeholder: string = 'assets/icones/default-image-product.svg';
  isAddProductMode = false;
  /** Guards against re-triggering the slide-out close more than once. */
  private isClosing = false;

  extractedNotes: { extracted: { category: string; text: string }[]; summary: string } | null = { extracted: [], summary: '' };

  addProductQuery = '';
  searchPage = 1;
  searchMetadata: IPagination | null = null;
  isLoadingMore = false;
  isSearchLoading = false;
  quotationCurrency: ICurrency | undefined = undefined;
  columns: Record<ColumnKey, IColumnConfig> = {
    product: { label: 'quotations_and_orders.order_line_columns.product', visible: true, locked: true },
    brand: { label: 'quotations_and_orders.order_line_columns.brand', visible: false },
    msrp: { label: 'quotations_and_orders.order_line_columns.msrp', visible: false },
    cost: { label: 'quotations_and_orders.order_line_columns.cost', visible: false },
    unit_price: { label: 'quotations_and_orders.order_line_columns.unit_price', visible: true, locked: true },
    quantity: { label: 'quotations_and_orders.order_line_columns.quantity', pickerLabel: 'quotations_and_orders.order_line_columns.quantity_picker', visible: true, locked: true },
    quantity_preferred_selling_unit: { label: 'quotations_and_orders.order_line_columns.quantity_preferred_selling_unit', pickerLabel: 'quotations_and_orders.order_line_columns.quantity_preferred_selling_unit_picker', visible: false },
    quantity_units: { label: 'quotations_and_orders.order_line_columns.quantity_units', pickerLabel: 'quotations_and_orders.order_line_columns.quantity_units_picker', visible: false },
    total_amount: { label: 'quotations_and_orders.order_line_columns.total_amount', visible: true, locked: true },
    profit_margin: { label: 'quotations_and_orders.order_line_columns.profit_margin', visible: false },
    delivery_date: { label: 'quotations_and_orders.order_line_columns.delivery_date', visible: false },
    stock: { label: 'quotations_and_orders.order_line_columns.stock', visible: false },
    notes: { label: 'quotations_and_orders.order_line_columns.notes', visible: false },
  };
  @ViewChild('addProductInput') addProductInput?: ElementRef<HTMLInputElement>;
  @ViewChild('addProductAutoTrigger', { read: MatAutocompleteTrigger }) addProductAutoTrigger?: MatAutocompleteTrigger;
  @ViewChild('ownerSearchInput') ownerSearchInput?: ElementRef<HTMLInputElement>;
  /** Focus targets for the quick-actions row's PO / Quote ID shortcuts. */
  /** Order-references block, so a deep link can open one of its rows. */
  @ViewChild('orderReferencesList') orderReferencesList?: DetailFieldListComponent;
  /** The email body's text-anchor renderer (WB-7625) — only needed to re-scroll after the expand. */
  @ViewChild(EmailBodyHighlightDirective) bodyHighlight?: EmailBodyHighlightDirective;
  private readonly rollbackSnapshots = new Map<string, IParseProduct>();
  private readonly selectedRowKeys = new Set<string>();
  get selectedProductsCount(): number {
    return this.selectedRowKeys.size;
  }
  private tempKeySeq = 1;
  private initialUpdateLineSignatures = new Map<number, string>();
  quotationId!: number;
  linesMetadata: IPagination | null = null;
  linesLoading: boolean = false;
  /** See `quotationsState.linesLoadFailed`; disarms the background page chain. */
  linesLoadFailed: boolean = false;
  private programmaticScrollPending = false;
  /**
   * WB-7430: the products list and the inline match editor live under the same `*ngIf`, so opening
   * the editor destroys the scroll viewport and returning from it re-creates it at scrollTop 0 —
   * a user reviewing line 40 was thrown back to line 1 after every match. Captured on the way in,
   * replayed on the way out. `null` means "nothing to restore".
   */
  private savedProductsScrollTop: number | null = null;

  objectCustomField$: Observable<IObjectCustomFields | null> = this.store.select((state) => state.settings.objectCustomFields);
  objectCustomFields: IObjectCustomFields | null = null;
  objectCustomFieldsParams: IObjectCustomFieldsParams = {
    object_type: RelatedObjectsTypes.ORDER,
    record_id: this.quotationId,
    visibility: [CustomFieldVisibilityTypes.BACKOFFICE],
    include_definitions: true,
  };
  currentLanguage: string = this.languageService.getCurrentLanguage();

  detailsDraft: {
    partnerId?: number;
    partnerName?: string;
    partnerCompanyId?: number;
    partnerCompanyName?: string;
    shippingAddress?: string;
    /**
     * The drafted shipping location itself (WB-8331). Every derived row of the
     * Shipping block — ERP id, tax codes, contacts — is built from this rather
     * than from `quotation.shipping_location`, so picking a new location
     * refreshes the whole block instead of only the name tag.
     */
    shippingLocation?: ILocation | null;
    customerPoNumber?: string;
    quoteId?: string;
    shippingDate?: string;
    ownerId?: number;
    ownerName?: string;
    comment?: string;
    paymentTermsId?: number | null;
    paymentTermsName?: string;
  } = {};
  private initialDetailsSignature = '';

  // ── Configurable detail blocks (WB-7463) ──────────────────────────────────
  // Same blocks, order and stored preferences as the order detail page: both
  // surfaces build them through `OrderDetailFieldsService`, so configuring one
  // configures the other.
  customerFields: IDetailField[] = [];
  shippingFields: IDetailField[] = [];
  orderReferenceFields: IDetailField[] = [];
  orderCustomFieldRows: IDetailField[] = [];
  fieldGroups: IDetailFieldGroup[] = [];
  paymentTermOptions: IPayment_term[] = [];
  /** The location's identifier codes, one tag per value. */
  taxCodeTags: ILocationCodeTag[] = [];
  /** Order fields the current role hides; mirrors `*appFieldVisible` in TS. */
  private hiddenOrderFields: string[] = [];

  // Owner/creator avatars, rendered exactly as on the order detail page.
  userChipInitials = userInitials;
  getUserColor = getUserColor;

  // Inline (non-modal) company/location editor — overlays the left panel.
  companyLocationEditMode = false;
  selectorCompany: ICustomer | null = null;
  selectorLocation: ILocation | null = null;
  selectorInitialStep: 'company' | 'location' | 'create' | undefined = undefined;
  selectorPrefill: { apartment?: string } | undefined = undefined;

  // Matched company's email registry (lowercased). Loaded lazily when the
  // post-match enrich dialog is opened so already-registered emails open
  // pre-toggled. Mirrors the order details page flow.
  private companyRegistryEmails: Set<string> = new Set<string>();
  private companyRegistryLoaded = false;
  private registryLoadedForCompanyId: number | null = null;
  private registryLoadCallbacks: Array<() => void> = [];

  // Emails the user chose in the enrich dialog, staged against the matched
  // company. They are written to the registry only when the panel's Save
  // succeeds (commitPendingCompanyEmails on UpdateQuotationDetailsSuccess), so
  // discarding the order edit also discards the enrichment.
  // `locationId` (WB-7092): when set, the emails commit to that location's
  // registry instead of the company's.
  private pendingCompanyEmails: { companyId: number; locationId: number | null; emails: string[] } | null = null;

  // WB-7569 — the splitting rule currently applicable to this order, or null.
  //
  // Kept in component state rather than read straight off the save response so
  // dismissing the preview modal is not terminal: the "Split applies" tag stays
  // in the header and re-opens the same proposal on click. Sourced from the
  // details-PATCH `segregation_check` after a save, and from
  // `preview-for-partner` on first load (so an order whose company was matched
  // in an earlier session still surfaces the proposal).
  segregationCheck: ISegregationCheck | null = null;
  /** Guards against one save opening the preview modal twice. */
  private segregationModalOpen = false;
  /**
   * Set when the details save currently in flight carried `id_company`, i.e. the
   * company may have changed. Only then is a response WITHOUT `segregation_check`
   * meaningful — see the `UpdateQuotationDetailsSuccess` handler.
   */
  private pendingCompanyChangeCheck = false;
  /**
   * A split proposal that arrived while line changes were still saving. Held
   * until `UpdateQuotationLinesSuccess` clears the staged work, so the modal
   * never opens on top of pending line edits it would discard.
   */
  private deferredSegregationOpen: (() => void) | null = null;
  /**
   * Set once a split actually went through, so the panel's eventual close tells
   * the opener the order changed. Sticky: the user usually keeps working in the
   * panel after splitting, and the close can come much later.
   */
  private didSplitOrder = false;

  // Inline (non-modal) product matching editor — overlays the products tab.
  productMatchEditMode = false;
  matchSelectorData: any = null;
  private matchTarget: IParseProduct | null = null;
  private matchMatchedTarget: IParseProduct | undefined = undefined;
  private matchIsUnmatchedSource = false;

  ownerSearchControl = new FormControl('', { nonNullable: true });
  ownerOptions: IOrderUser[] = [];
  ownerSearchLoading = false;
  ownerEditMode = false;
  private ownerSearch$ = new Subject<string>();

  dataLoading = false;
  loadError = false;

  readonly loadingStatusSteps: string[] = [
    'quotations_and_orders.side_by_side_panel.loading_step_order_details',
    'quotations_and_orders.side_by_side_panel.loading_step_ai_analysis',
    'quotations_and_orders.side_by_side_panel.loading_step_documents',
    'quotations_and_orders.side_by_side_panel.loading_step_products',
  ];
  loadingStatusIndex = 0;
  private loadingStatusInterval: ReturnType<typeof setInterval> | null = null;
  private loadingStepsShown = 0;
  private dataReady = false;

  destroy$ = new Subject<void>();

  get viewMode(): boolean {
    // WB-7478: `sent_to_erp` was missing here, so an order already pushed to the
    // ERP still rendered editable inputs. Aligned with the ERP_STATUSES used by
    // list-quotations and details-quotes.
    if (this.quotation?.is_archived) return true;
    if (!['sale', 'done', 'sent_to_erp'].includes(this.quotation?.status ?? '')) return false;
    // WB-7957/WB-8276: a 'sale'/'done' order whose async ERP sync settled into an
    // error is still fixable -- same exception as DetailsQuotesComponent.stillEditable().
    // 'sent_to_erp' is excluded on purpose (checked first, so featureFlags is never
    // touched on that path): that status means the order already reached the ERP
    // via the synchronous path, so there is nothing to retry.
    if (
      this.quotation?.status !== 'sent_to_erp' &&
      ['failed', 'canceled', 'not_applicable'].includes(this.quotation?.erp_sync?.sync_status ?? '') &&
      this.featureFlags.asyncErpSyncEnabled
    ) {
      return false;
    }
    return true;
  }

  /** True when the panel was opened from Smart Inbox (approval-surface mode). */
  get isSmartInboxOrigin(): boolean {
    return this.data?.origin === 'smart-inbox';
  }

  /**
   * Records that have reached the ERP are read-only. Computed front-end only,
   * per the ticket — surfaced as the amber "Read-only" badge in the header.
   */
  get isReadOnlyRecord(): boolean {
    return ['done', 'sent_to_erp'].includes(this.quotation?.status ?? '');
  }

  /**
   * The status the approve transition starts from. `null` when the record is not
   * in an approvable state, which also hides the Approve action.
   */
  get approvableFromStatus(): 'to_be_validated' | 'pending_inventory' | null {
    const status = this.quotation?.status ?? '';
    if (status === 'to_be_validated' || status === 'pending_inventory') return status;
    return null;
  }

  get canApproveOrder(): boolean {
    return this.isSmartInboxOrigin && !!this.approvableFromStatus && !this.isReadOnlyRecord;
  }

  /**
   * Approve is blocked while there are unsaved edits: approving would transition the
   * order on the server while the user's pending changes were still local, silently
   * discarding them. They save first, then approve.
   */
  get isApproveBlocked(): boolean {
    return this.isDirty;
  }

  get currentLoadingStatusKey(): string {
    return this.loadingStatusSteps[this.loadingStatusIndex] ?? this.loadingStatusSteps[0];
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SideBySideCorrectionPanelData,
    private dialogRef: MatDialogRef<SideBySideCorrectionPanelComponent>,
    private dialog: MatDialog,
    private store: Store<AppState>,
    private actions$: Actions,
    private translateService: TranslateService,
    private ordersService: OrdersService,
    private tablePrefs: TablePreferencesService,
    private customerEmailService: CustomerEmailService,
    private commonService: CommonService,
    private el: ElementRef<HTMLElement>,
    private quotesService: QuotesService,
    private priceCandidates: PriceCandidatesStore,
    public featureFlags: FeatureFlagService,
    public productCode: ProductCodeService,
    private languageService: LanguageService,
    private productsService: ProductsService,
    private orderStatusDialog: OrderStatusDialogService,
    private exportService: QuotationExportService,
    private quickActionsPrefs: QuickActionsPreferencesService,
    private segregationPreview: SegregationPreviewService,
    private productCustomFieldColumns: ProductCustomFieldColumnsService,
    private orderDetailFields: OrderDetailFieldsService,
  ) { }

  ngOnInit(): void {
    this.priceCandidates.retain();
    this.dialogRef.disableClose = true;
    // Column visibility (including the pricing-columns default) is hydrated
    // from the order's own data once it loads — see applyQuotationData.
    this.initColumns();

    // Definitions arrive asynchronously, so the columns are hydrated again once
    // they land (and whenever the settings change under us).
    this.productCustomFieldColumns.columns$().pipe(takeUntil(this.destroy$)).subscribe((columns) => {
      this.syncCustomFieldColumns(columns);
      this.initColumns();
    });

    this.dialogRef.backdropClick().pipe(
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.close();
    });

    this.dialogRef.keydownEvents().pipe(
      takeUntil(this.destroy$)
    ).subscribe((event: KeyboardEvent) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      this.close();
    });

    this.actions$.pipe(
      ofType(UpdateQuotationLinesSuccess),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      // Lines changed on the server (matches/updates/removals), so the cached bulk
      // alternatives — keyed by line id — are now stale. Evict them (both matched and
      // unmatched) so reopening a line refetches, mirroring the details-quotes flow.
      // The price-candidates cache is evicted by InvalidatePriceCandidatesEffect$ on
      // this same action, for every surface at once.
      if (this.quotation?.id) {
        this.quotesService.clearAlternativesBulkCache(this.quotation.id);
      }
      // The staged line changes are now committed server-side. Drop them before
      // the refetch, or the newly-added rows come back inside `quotation.products`
      // while still sitting in the "not yet saved" sublist — showing twice.
      this.resetPendingLineChanges();
      // WB-7569 — a split proposal from the same save waited for this moment: the
      // staged line work is committed and cleared, so the modal can no longer
      // discard anything. Run it INSTEAD of closing; it closes when it resolves.
      const deferred = this.deferredSegregationOpen;
      if (deferred) {
        this.deferredSegregationOpen = null;
        // Only skip the close if the modal really opened — otherwise `deferred`
        // never runs and the panel would hang open.
        if (this.openSplitPreview(deferred)) return;
      }
      this.closeAfterSave();
    });

    this.actions$.pipe(
      ofType(UpdateQuotationDetailsSuccess),
      takeUntil(this.destroy$)
    ).subscribe((action) => {
      // Order details (incl. the company match) persisted — now commit any
      // emails the user staged in the enrich dialog. Option 2: the registry
      // write happens only on a successful save, never if the edit is discarded.
      this.commitPendingCompanyEmails();
      // WB-8331 review: take the server's location back over the drafted one
      // BEFORE the rebaseline, so the new baseline is the committed state. A
      // confirmed AI suggestion drafts only {id, name, address}; this is where
      // its ERP id, tax codes and contacts arrive, and the panel may well stay
      // open (pending line changes, the segregation modal) to show them.
      this.reseedShippingLocationFromServer(true);
      this.initialDetailsSignature = this.buildDetailsSignature();
      // The details are clean as of this line; anything below reading `isDirty`
      // must not see the pre-save memo.
      this.invalidateDirtyCache();

      // WB-7569 — the backend embeds `segregation_check` when the company just
      // assigned makes a splitting rule applicable. The order-details page has
      // always consumed it; this panel did not, so a company matched manually
      // from Smart Inbox skipped the split and approved one undivided order.
      //
      // Presence-checked, NOT truthiness-checked. The backend only attaches the
      // field on a FIRST company assignment (`is_first_assignment` in
      // quotation_api.update_quotation), so its absence means "this PATCH was not
      // a first assignment" — never "no rule applies". Reading absence as the
      // latter wiped the tag on any unrelated save, and on the inline
      // location-creation response `onSelectorCompleted` dispatches, which
      // structurally cannot carry it. Since the refresh below only ever ran on
      // first load, the tag never came back.
      const changes = action.changes as any;
      const carriedCompanyChange = this.pendingCompanyChangeCheck;
      this.pendingCompanyChangeCheck = false;

      if (changes && 'segregation_check' in changes) {
        const check = changes.segregation_check;
        this.segregationCheck = this.segregationPreview.isApplicable(check) ? check : null;
        if (this.autoOpenSegregationIfApplicable()) return;
      } else if (carriedCompanyChange) {
        // The save carried customer info but came back without the field, so the
        // company moved without being a FIRST assignment (A → B, or an inline
        // location creation). The proposal should still be offered — users must
        // not have to remember that splitting is possible — so ask the backend
        // directly instead of inferring anything from the absence.
        //
        // The post-save close waits for the answer: closing first would animate
        // the panel away (order-details origin) and orphan the modal.
        this.refreshSegregationApplicability({
          force: true,
          onSettled: () => {
            if (this.autoOpenSegregationIfApplicable()) return;
            if (!this.hasLineChanges()) this.closeAfterSave();
          },
        });
        return;
      }

      if (!this.hasLineChanges()) {
        this.closeAfterSave();
      }
    });

    this.store.select((s) => s.products.searchMetadata).pipe(
      takeUntil(this.destroy$)
    ).subscribe((meta) => {
      this.searchMetadata = meta;
      this.isLoadingMore = false;
      this.isSearchLoading = false;
    });

    this.ownerSearch$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$),
      switchMap((q) => {
        this.ownerSearchLoading = true;
        return this.ordersService.searchBackofficeUsers(q, 50).pipe(
          finalize(() => { this.ownerSearchLoading = false; })
        );
      })
    ).subscribe((users) => {
      this.ownerOptions = users;
    });
    this.ownerSearch$.next('');

    const quotationId = this.data?.quotationId;
    if (quotationId == null) {
      this.loadError = true;
      return;
    }

    this.quotationId = quotationId;
    this.objectCustomFieldsParams = { ...this.objectCustomFieldsParams, record_id: this.quotationId };
    this.store.dispatch(GetObjectCustomFields({ params: this.objectCustomFieldsParams }));

    // Options for the inline payment-terms lookup on the customer block.
    this.store.dispatch(FetchAllpaymentTerms());
    this.store
      .select((state) => state.customers.allPaymentTerms)
      .pipe(takeUntil(this.destroy$))
      .subscribe((terms: IPayment_term[]) => {
        this.paymentTermOptions = terms ?? [];
        this.buildDetailFields();
      });

    // Role-level field visibility, read here because the rows are generated in
    // TypeScript rather than gated by `*appFieldVisible`.
    this.store
      .select(selectHiddenFieldsForModule('order'))
      .pipe(takeUntil(this.destroy$))
      .subscribe((hidden: string[]) => {
        this.hiddenOrderFields = hidden ?? [];
        this.buildDetailFields();
      });

    this.objectCustomField$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((objectCustomFields) => {
      if (objectCustomFields) {
        this.objectCustomFields = objectCustomFields;
        // Custom fields are one of the configurable blocks (WB-7463).
        this.buildDetailFields();
      }
    });

    this.store.select((s) => s.quotations.linesMetadata).pipe(
      takeUntil(this.destroy$)
    ).subscribe((m) => {
      this.linesMetadata = m;
      // Drives the background line-pagination chain after each page lands (incl. the initial
      // page 1, which never flips linesLoading, so a linesLoading transition alone can't catch it).
      this.maybeAutoLoadRemainingLines();
    });
    this.store.select((s) => s.quotations.linesLoading).pipe(
      takeUntil(this.destroy$)
    ).subscribe((l) => {
      this.linesLoading = l;
      // Each AppendQuotationPage flips this true→false on completion; chain the next page then.
      if (!l) this.maybeAutoLoadRemainingLines();
    });
    this.store.select((s) => s.quotations.linesLoadFailed).pipe(
      takeUntil(this.destroy$)
    ).subscribe((failed) => this.linesLoadFailed = failed);

    const quotationInStore = this.store.select((s) => s.quotations.quotation);
    const sourceContentInStore = this.store.select((s) => s.quotations.quotationSourceContent);
    const sourceIdInStore = this.store.select((s) => s.quotations.quotationSourceQuotationId);
    const coordsInStore = this.store.select((s) => s.quotations.quotationDocumentCoordinates);
    const coordsIdInStore = this.store.select((s) => s.quotations.quotationDocumentCoordinatesQuotationId);

    quotationInStore.pipe(take(1)).subscribe((q) => {
      // From Smart Inbox, always refetch. Nothing there owns this store slot, and
      // `validateOrderSuccess` carries no status, so a cached same-id order can be a
      // pre-approval snapshot — rendering it would show `to_be_validated` with every
      // input editable on an order already in the ERP. From the order-details page the
      // page itself owns and refreshes this slot, so the cache short-circuit stays.
      if (!q || q.id !== quotationId || this.isSmartInboxOrigin) {
        this.dataLoading = true;
        this.startLoadingStatusInterval();
        this.store.dispatch(GetQuotationById({ id: quotationId, skipGlobalLoader: true, paginate_lines: true, page: 1, limit: DEFAULT_LINES_PAGE_SIZE, include_ai_details: false }));
      }
    });
    // Refetch source content when the cached content belongs to a different quotation
    // (e.g. reopening the panel for another order from Smart Inbox); a bare `if (!c)`
    // check would keep the previous order's stale source content.
    combineLatest([sourceContentInStore, sourceIdInStore]).pipe(take(1)).subscribe(([c, srcId]) => {
      if (!c || srcId !== quotationId) {
        this.store.dispatch(GetQuotationSourceContent({ id: quotationId, skipGlobalLoader: true }));
      }
    });
    // WB-6815 document coordinates (hover highlights). Fetched on its own — never gates the panel
    // (see the apply gate below): a slow/failing/empty coordinate load must not block rendering.
    combineLatest([coordsInStore, coordsIdInStore]).pipe(take(1)).subscribe(([c, id]) => {
      if (!c || id !== quotationId) {
        this.store.dispatch(GetQuotationDocumentCoordinates({ id: quotationId, skipGlobalLoader: true }));
      }
    });
    // Apply coordinates whenever they resolve for THIS quotation, merging onto the lines by id.
    // Runs independently of applyQuotationData, so it handles coords arriving either before (lines
    // not built yet → applyQuotationData re-applies at the end) or after the lines are built.
    combineLatest([coordsInStore, coordsIdInStore]).pipe(
      filter(([_c, id]) => id === quotationId),
      takeUntil(this.destroy$)
    ).subscribe(([coords]) => {
      this.documentCoordinates = coords ?? null;
      this.applyDocumentCoordinates(this.documentCoordinates);
      // Coordinates cover EVERY line but lines paginate — kick off the background load of the
      // remaining pages now (handles coords arriving before page 1's metadata was even set).
      this.maybeAutoLoadRemainingLines();
    });

    // Approval outcome. The panel stays open across the request so it can present the
    // ERP-conflict follow-ups; see onApproveResolved.
    this.actions$.pipe(
      ofType(validateOrderSuccess),
      takeUntil(this.destroy$)
    ).subscribe((action) => this.onApproveResolved(action.quotation));

    this.actions$.pipe(
      ofType(validateOrderError),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      // Leave the panel open on failure so the edits are not lost and the user can
      // retry; the effect has already surfaced the error.
      this.approveInFlight = false;
    });

    // Cancel / archive / delete: close only once the server has actually applied the
    // change, so the opener's refresh cannot read pre-mutation state.
    this.actions$.pipe(
      ofType(cancelQuotationSuccess),
      takeUntil(this.destroy$)
    ).subscribe(() => this.closeAfterMutation(SIDE_BY_SIDE_RESULT_CANCELLED));

    this.actions$.pipe(
      ofType(ArchiveQuotationSuccess),
      takeUntil(this.destroy$)
    ).subscribe(() => this.closeAfterMutation(SIDE_BY_SIDE_RESULT_ARCHIVED));

    this.actions$.pipe(
      ofType(deleteQuotationSuccess),
      takeUntil(this.destroy$)
    ).subscribe(() => this.closeAfterMutation(SIDE_BY_SIDE_RESULT_DELETED));

    this.actions$.pipe(
      ofType(cancelQuotationError, ArchiveQuotationError, deleteQuotationError),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      // Stay open on failure; the effect has already surfaced the error.
      this.mutationInFlight = null;
    });

    this.actions$.pipe(
      ofType(GetQuotationByIdError, GetQuotationSourceContentError),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.loadError = true;
      this.dataLoading = false;
      this.clearLoadingStatusInterval();
    });

    let initialized = false;
    // Gate the first apply on the source content being resolved for THIS quotation
    // (srcId === quotationId), so applyQuotationData never runs with stale source content
    // and always sees `ai_details` hydrated from it. quotationSourceQuotationId is set on
    // GetQuotationSourceContentSuccess for both the has-content and empty-content cases.
    combineLatest([quotationInStore, sourceContentInStore, sourceIdInStore]).pipe(
      filter(([q, _c, srcId]) => q != null && q.id === quotationId && srcId === quotationId),
      takeUntil(this.destroy$)
    ).subscribe(([quotation, quotationSourceContent]) => {
      if (!initialized) {
        initialized = true;
        this.applyQuotationData(quotation!, quotationSourceContent ?? undefined);
        this.dataReady = true;
        if (this.loadingStepsShown >= this.loadingStatusSteps.length) {
          this.finishLoading();
        }
      } else {
        this.mergeQuotationData(quotation!);
      }
    });

    // Last, and guarded: the quick-actions row is decoration on top of the order.
    // Reading its preferences must never be able to abort ngOnInit before the
    // subscriptions above are wired, or the order would never load at all.
    try {
      this.initQuickActions();
    } catch {
      this.quickActionsEnabled = false;
      this.quickActionFields = [];
    }
  }

  ngOnDestroy(): void {
    this.removePanelScrollListener();
    this.clearLoadingStatusInterval();
    // The store is app-wide and this panel is a dialog over an order screen, so
    // clearing here wipes the candidates out from under it. Releasing clears
    // only when no surface is left reading.
    this.priceCandidates.release();
    this.destroy$.next();
    this.destroy$.complete();
  }

  private applyQuotationData(quotation: IQuotationDetail, quotationSourceContent: IQuotationSourceContent | undefined): void {
    this.quotation = quotation;
    // Pricing-column visibility defaults from THIS order's own creation-time
    // snapshot (WB-7024), not the company's current setting — so changing the
    // company setting never retroactively affects an order created under a
    // different one. The dialog is opened per-order, so this only needs to
    // run once, on first load.
    this.hidePricingColumns = !!quotation.hide_pricing_columns;
    if (this.hidePricingColumns) {
      // One-time cleanup so this default takes effect even for users whose
      // stored prefs predate this setting (WB-6463) — see
      // TablePreferencesService.resetVisibilityOnce.
      this.tablePrefs.resetVisibilityOnce(
        SideBySideCorrectionPanelComponent.THIS_TABLE_KEY,
        [...SideBySideCorrectionPanelComponent.PRICING_KEYS],
        'wb6463_hide_pricing_columns_side_by_side'
      );
    }
    this.initColumns();
    this.loadPriceCandidates();
    this.quotationSourceContent = quotationSourceContent;
    this.quotationCurrency = quotation?.currency ?? undefined;
    this.orderDeliveryDate = quotation?.shipping_date ?? '';
    // Provisional only. An order with attachments starts collapsed, but whether it STAYS collapsed
    // is settled by `autoSelectPreviewAttachment` below (WB-8267): the body is the fallback source
    // view, so it re-opens when the lines turn out to name no attachment at all.
    this.contentExpanded = !quotationSourceContent?.email?.attachments?.length;
    this.products = (quotation.products || []).map((p) => {
      const normalized = this.normalizeProductHandlingUnits(p);
      this.ensureRowKey(normalized, 'prod');
      return normalized;
    });
    this.unmatchedProducts = (quotation.ai_details?.unmatched_order_lines || []).map((p: any) => {
      const normalized: any = { ...p };
      this.ensureRowKey(normalized, 'unmatched');
      return normalized as IParseProduct;
    });
    // Document Coordinates (WB-6815): real per-line backend coordinates drive the hover highlights
    // (see `previewHighlight` / `lineRegions`). Applied here in case they resolved before the lines
    // were built; the coords subscription re-applies if they arrive after.
    this.applyDocumentCoordinates(this.documentCoordinates);
    this.store.dispatch(ClearProducts());
    // Preview the order's real attachment. Runs after `products` / `unmatchedProducts` are built
    // above — the resolver needs their `source` values (WB-7399).
    if (quotationSourceContent?.email?.attachments?.length) {
      this.autoSelectPreviewAttachment();
    } else if (quotation.segregation_info?.source_id) {
      // Split children created before WB-7337 (or by any path that doesn't inherit
      // message_id / source_attachment_provider_ids) have no documents of their own.
      // Fall back to the original order's files — we already have the source id via
      // segregation_info, no backend change needed.
      this.loadFallbackSourceAttachments(quotation.segregation_info.source_id, quotation.id);
    }
    this.initDetailsDraft();
    this.initialUpdateLineSignatures.clear();
    (this.products || []).forEach((p) => {
      const line = this.toUpdateLine(p);
      if (line) {
        this.initialUpdateLineSignatures.set(line.id, JSON.stringify(line));
      }
    });
    this.initialDetailsSignature = this.buildDetailsSignature();
    // `ai_details` is optional on the source content and was dereferenced with a
    // plain `.` here: an order whose extraction is absent (a manual order, or an
    // AI one whose ai_details have not landed) threw right here, and the panel
    // stayed on its loading state for ever with no visible error.
    this.extractedNotes = this.normalizeExtractedNotes(quotationSourceContent?.ai_details?.extracted_info?.notes);
    // Only on first load: later store updates go through `mergeQuotationData`, and
    // re-checking on every merge would fire a request per refetch for a tag whose
    // authoritative value already comes back with each save.
    this.refreshSegregationApplicability();
  }

  /**
   * Split children may have no documents of their own (see WB-7337 on the backend — older
   * splits, or any path that doesn't inherit message_id / source_attachment_provider_ids,
   * still land here). Front-end-only fallback: fetch the source order's own attachments and
   * merge just those in (see `withFallbackAttachments`), so the side-by-side view always has
   * something to show. Never blocks a retry — the caller only invokes this when attachments
   * are still missing, so it's safe to call again whenever that's still true.
   */
  private loadFallbackSourceAttachments(sourceId: number, forQuotationId: number): void {
    this.quotesService.getFallbackSourceAttachments(sourceId).pipe(
      takeUntil(this.destroy$)
    ).subscribe((attachments) => {
      // The panel may have moved on to a different order by the time this resolves.
      if (this.quotationId !== forQuotationId || !attachments.length) {
        return;
      }
      this.quotationSourceContent = withFallbackAttachments(this.quotationSourceContent, attachments);
      // A brand-new list of files: re-open the decision — both the preview and the body default.
      this.previewMatchLatched = false;
      this.bodyDefaultApplied = false;
      this.autoSelectPreviewAttachment();
    });
  }

  /**
   * WB-6815: merge real per-line coordinates onto the already-built lines. Matched lines join by
   * `order_line_id`; unmatched by their DB id (`_unmatchedLineId` ?? `id`) — the same ids the backend
   * keys `lines` / `unmatched_lines` by (parse_unmatched_order_line emits `'id': order_line.id`).
   * No-op when there are no coords, so it's safe to call before the lines exist (empty arrays) or
   * repeatedly. In-place assignment; `previewHighlight` / `lineRegions` are getters and pick it up
   * next CD cycle.
   */
  private applyDocumentCoordinates(coords: IDocumentCoordinatesResponse | null): void {
    // Real coords only apply on deployed envs; skip under useMockData (no backend coords there).
    if (environment.useMockData) {
      return;
    }
    applyDocumentCoordinatesToLines(this.products, this.unmatchedProducts, coords);
    // Coordinates mutate source_locations in place WITHOUT changing the products array
    // references or lengths, so the lineRegions cache (keyed on exactly those) would keep the
    // empty regions it built before the async coords arrived — leaving doc->list hover dead on the
    // FIRST open until the panel is reopened (by then the coords are already cached in the store).
    // Invalidate the cache so the getter rebuilds a NEW array; its changed reference then triggers
    // the files-previewer ngOnChanges(lineRegions) -> recompute that (re)draws the hotspot layers.
    this._lineRegionsCache = null;
    this._cellRegionsCache = null; // same reasoning for the spreadsheet path (WB-7592)
    this._textAnchorRegionsCache = null; // and for the email-body path (WB-7625)
  }

  private mergeQuotationData(quotation: IQuotationDetail): void {
    this.quotation = quotation;
    this.quotationCurrency = quotation?.currency ?? undefined;
    this.reseedShippingLocationFromServer();
    // The product set can change under the panel (a line matched, a line added),
    // so re-ask: otherwise a newly-matched line shows the answer to a question
    // about another product.
    this.loadPriceCandidates();

    const storeProductIds = new Set(
      (quotation.products || [])
        .map((p) => p.order_line_id)
        .filter((id): id is number => id != null)
    );
    this.products = this.products.filter(
      (p) => p.order_line_id == null || storeProductIds.has(p.order_line_id)
    );
    const existingIds = new Set(
      this.products
        .map((p) => p.order_line_id)
        .filter((id): id is number => id != null)
    );
    const appended = (quotation.products || [])
      .filter((p) => p.order_line_id != null && !existingIds.has(p.order_line_id))
      .map((p) => {
        const normalized = this.normalizeProductHandlingUnits(p);
        this.ensureRowKey(normalized, 'prod');
        const line = this.toUpdateLine(normalized);
        if (line) {
          this.initialUpdateLineSignatures.set(line.id, JSON.stringify(line));
        }
        return normalized;
      });
    if (appended.length > 0) {
      this.products = [...this.products, ...appended];
    }

    // Rebaseline the lines the server sent for rows we already had, not just the
    // appended ones: whatever the server returns is by definition not a pending local
    // edit, and leaving those baselines stale keeps `isDirty` stuck true.
    (quotation.products || []).forEach((serverProduct) => {
      if (serverProduct.order_line_id == null) return;
      const line = this.toUpdateLine(serverProduct);
      if (line) {
        this.initialUpdateLineSignatures.set(line.id, JSON.stringify(line));
      }
    });

    const storeUnmatchedIds = new Set(
      (quotation.ai_details?.unmatched_order_lines || []).map((p) => p.id)
    );
    this.unmatchedProducts = this.unmatchedProducts.filter((p) => {
      const unmatchedId = (p as any)._unmatchedLineId ?? p.id;
      return storeUnmatchedIds.has(unmatchedId);
    });
    // Re-attach coordinates: the /document_coordinates payload covers EVERY line up-front, but
    // lines beyond the first page arrive here via "load more" (AppendQuotationPage) — so lines
    // appended above would otherwise never get their source_locations / highlight. Idempotent.
    this.applyDocumentCoordinates(this.documentCoordinates);
  }

  /**
   * A location's shipping address, whichever payload shape it arrived in
   * (WB-8331).
   *
   * The order's own `location` / `shipping_location` come from the backend's
   * `parse_simplified_location`, which exposes `shipping_address`. The company
   * locations the selector hands back come from `parse_location`, which carries
   * the very same value under its raw Odoo name, `apartment`, and has no
   * `shipping_address` key at all — so reading only the latter left the address
   * `undefined` after a manual pick and the template fell back to the PREVIOUS
   * location's address.
   */
  private static shippingAddressOf(location?: ILocation | null): string | undefined {
    return location?.shipping_address ?? location?.apartment ?? undefined;
  }

  /**
   * The location the Shipping block edits: the order's own delivery location,
   * falling back to `location` for an order that carries no
   * `partner_shipping_id` (WB-7836 split the two; orders predating it have only
   * the latter).
   *
   * Every row of the block resolves through here — name, address, ERP id, tax
   * codes, contacts — and so does the save baseline in `buildDetailsPayload`.
   * Reading `location` for the name while the rest read `shipping_location`
   * rendered the billing location's name beside the shipping location's company
   * on any order where the two differ (WB-8331 review).
   */
  private shippingLocationOf(quotation?: IQuotationDetail | null): ILocation | null {
    return quotation?.shipping_location ?? quotation?.location ?? null;
  }

  /**
   * Take the server's shipping location back over the drafted one, but only
   * while there is nothing drafted to lose (WB-8331 review).
   *
   * `initDetailsDraft` runs once, on first load; every later store update comes
   * through `mergeQuotationData`. Since the Shipping block now renders from the
   * draft, a draft that is never refreshed shadows the server for the rest of
   * the panel's life — so a save that leaves the panel open (pending line
   * changes, the segregation modal) kept showing the client-side object, and a
   * confirmed AI suggestion kept its blank ERP id and tax codes instead of the
   * full location the save had just returned.
   *
   * Guarded on dirtiness, because the whole point of drafting is that an
   * uncommitted pick outlives a refetch. `force` is the one case where the
   * guard must not apply: a save that just succeeded. NgRx runs reducers before
   * `actions$` subscribers, so by the time `mergeQuotationData` sees the new
   * state the draft is still measured against the PRE-save baseline and reads
   * dirty — the guard would skip every post-save refresh there is.
   */
  private reseedShippingLocationFromServer(force = false): void {
    if (!force && this.hasDetailsChanges()) return;
    const shippingLocation = this.shippingLocationOf(this.quotation);
    this.detailsDraft.partnerId = shippingLocation?.id;
    this.detailsDraft.partnerName = shippingLocation?.name;
    this.detailsDraft.shippingLocation = shippingLocation;
    this.detailsDraft.shippingAddress =
      SideBySideCorrectionPanelComponent.shippingAddressOf(shippingLocation);
    this.buildDetailFields();
  }

  private initDetailsDraft(): void {
    const location = this.quotation?.location;
    const shippingLocation = this.shippingLocationOf(this.quotation);
    const orderCompany = this.quotation?.order_company;
    this.detailsDraft = {
      partnerId: shippingLocation?.id,
      partnerName: shippingLocation?.name,
      // The company row represents the billing company (order_company); the save payload's
      // `id_company` is the billing company too (see buildDetailsPayload).
      partnerCompanyId: orderCompany?.id ?? location?.id_company,
      partnerCompanyName: orderCompany?.name ?? location?.company_name,
      shippingAddress: SideBySideCorrectionPanelComponent.shippingAddressOf(shippingLocation),
      shippingLocation,
      customerPoNumber: this.quotation?.customer_po_number ?? undefined,
      quoteId: this.quotation?.quote_id ?? undefined,
      shippingDate: this.quotation?.shipping_date ?? undefined,
      ownerId: this.quotation?.owner?.id ?? undefined,
      ownerName: this.quotation?.owner?.name ?? undefined,
      comment: this.quotation?.comment ?? '',
      paymentTermsId: this.quotation?.payment_terms?.id ?? null,
      paymentTermsName: this.quotation?.payment_terms?.name ?? undefined,
    };
    this.buildDetailFields();
  }

  private startLoadingStatusInterval(): void {
    this.clearLoadingStatusInterval();
    this.loadingStepsShown = 0;
    this.dataReady = false;
    this.loadingStatusInterval = setInterval(() => {
      this.loadingStepsShown++;
      this.loadingStatusIndex =
        (this.loadingStatusIndex + 1) % this.loadingStatusSteps.length;
      if (this.dataReady && this.loadingStepsShown >= this.loadingStatusSteps.length) {
        this.finishLoading();
      }
    }, 500);
  }

  private finishLoading(): void {
    this.dataLoading = false;
    this.clearLoadingStatusInterval();
  }

  private clearLoadingStatusInterval(): void {
    if (this.loadingStatusInterval) {
      clearInterval(this.loadingStatusInterval);
      this.loadingStatusInterval = null;
    }
  }

  get displayedProducts(): IParseProduct[] {
    return [...(this.products || []), ...(this.newProducts || [])];
  }

  get hasMoreLines(): boolean {
    return !!this.linesMetadata && this.linesMetadata.page < this.linesMetadata.pages;
  }

  loadMoreLines(): void {
    if (this.linesLoading) return;
    if (!this.hasMoreLines) return;
    this.store.dispatch(AppendQuotationPage({ id: this.quotationId }));
  }

  /** True once the /document_coordinates payload has arrived with at least one located line. */
  private get hasDocumentCoordinates(): boolean {
    return !!(this.documentCoordinates?.lines?.length || this.documentCoordinates?.unmatched_lines?.length);
  }

  /**
   * Document Coordinates (WB-4974 / FE-5): the /document_coordinates payload covers EVERY order line
   * up front, but lines are paginated (DEFAULT_LINES_PAGE_SIZE per page) and only page 1 loads on open.
   * Highlights/hotspots for lines on later pages would stay dead until the user manually scrolled. So,
   * once coordinates are present, eagerly pull the remaining pages in the BACKGROUND — one
   * AppendQuotationPage at a time, each chained off the previous page's completion (via the
   * linesMetadata / linesLoading subscriptions). Bounded and idempotent: the `linesLoading` guard
   * prevents overlapping requests and the recursion the reducer's linesLoading:true would otherwise
   * cause, and it self-stops once `hasMoreLines` is false. No-op without coordinates, so orders without
   * the coordination feature keep the lazy scroll-to-load behaviour. The panel stays interactive the
   * whole time — the user never waits for the chain to finish.
   */
  private maybeAutoLoadRemainingLines(): void {
    if (!this.shouldAutoLoadAllLines) return;
    // A failed page leaves `linesMetadata` untouched, so `hasMoreLines` stays true while
    // the error flips `linesLoading` back to false — which is exactly the transition this
    // chain listens on. Without this guard the two would re-dispatch each other forever
    // against an endpoint that is already failing. The manual "Load more" button is not
    // gated, so a user-driven retry still works and clears the flag on success.
    if (this.linesLoadFailed) return;
    if (this.linesLoading) return;
    if (!this.hasMoreLines) return;
    this.store.dispatch(AppendQuotationPage({ id: this.quotationId }));
  }

  /**
   * Two independent reasons to pull every page in the background: document coordinates (highlights
   * for later pages would otherwise stay dead), and WB-8278's grouped mode (grouping a partial list
   * misrepresents which lines need attention). Either one is enough.
   */
  private get shouldAutoLoadAllLines(): boolean {
    return this.hasDocumentCoordinates || this.lineGroupingMode === 'resolution';
  }

  /**
   * True while the background load still has pages to fetch — used to swap the manual
   * "Load more" button for a "some lines still loading" hint (their doc highlights aren't wired yet).
   *
   * `linesLoadFailed` has to be tested here too, not just in `maybeAutoLoadRemainingLines`. A failed
   * page leaves `hasMoreLines` true while `linesLoading` goes false, so without it the hint would
   * claim the chain is still working when it has stopped, AND the template hides the Load more
   * button on `autoLoadingLines` — leaving no way to retry. The chain is not loading after a
   * failure, so the manual affordance is exactly what should come back.
   */
  get autoLoadingLines(): boolean {
    return this.shouldAutoLoadAllLines && !this.linesLoadFailed && (this.hasMoreLines || this.linesLoading);
  }

  onViewportScroll(event: Event): void {
    if (this.programmaticScrollPending) return;
    const el = event.target as HTMLElement;
    const threshold = 120;
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;
    if (nearBottom) this.loadMoreLines();
  }

  onUserScrollIntent(): void {
    this.programmaticScrollPending = false;
  }

  /** The scrolling products list container. Absent whenever an inline overlay replaced the list. */
  private get productsViewport(): HTMLElement | null {
    return (this.el?.nativeElement?.querySelector('.products-viewport-side-by-side') as HTMLElement | null) ?? null;
  }

  /** WB-7430: remember where the user was reading before an inline overlay unmounts the list. */
  private saveProductsScrollPosition(): void {
    this.savedProductsScrollTop = this.productsViewport?.scrollTop ?? null;
  }

  /**
   * WB-7430: put the list back where {@link saveProductsScrollPosition} left it. Deferred to the next
   * task so the `*ngIf` swap has re-rendered the viewport; rows are fixed-height (70px) so the same
   * offset lands on the same line, and the browser clamps if the list got shorter (e.g. an unmatched
   * line was ignored away). Not guarded by `programmaticScrollPending`: restoring the user's own
   * position should keep triggering the near-bottom `loadMoreLines`, exactly as being there did.
   */
  private restoreProductsScrollPosition(): void {
    const target = this.savedProductsScrollTop;
    this.savedProductsScrollTop = null;
    if (!target) return;
    setTimeout(() => {
      const viewport = this.productsViewport;
      if (viewport) viewport.scrollTop = target;
    });
  }

  isColumnVisible(key: keyof SideBySideCorrectionPanelComponent['columns']): boolean {
    return !!this.columns?.[key]?.visible;
  }

  /** Visible columns in display order. */
  get orderedColumns(): ColumnKey[] {
    return this.columnOrder.filter((key) => this.isColumnVisible(key));
  }

  /**
   * Visible custom field columns only (WB-7619). The hardcoded cells are written
   * out one by one in the template; these are rendered by a loop appended after
   * them and placed by the grid `order` index, so DOM order does not matter.
   */
  get visibleCustomFieldColumns(): ColumnKey[] {
    return this.orderedColumns.filter((key) => this.isCustomFieldColumn(key));
  }

  /** CSS `order` for a grid cell (1-based; the checkbox cell keeps default 0). */
  columnOrderIndex(key: ColumnKey): number {
    return this.gridOrderIndex[key] ?? 0;
  }

  get gridTemplateColumns(): string {
    // Leading 30px checkbox track (omitted in read-only view), then one track
    // per visible column in the current order.
    const cols: string[] = this.viewMode ? [] : ['30px'];
    this.orderedColumns.forEach((key) => cols.push(this.COLUMN_WIDTHS[key] ?? 'minmax(140px, 1fr)'));
    return cols.join(' ');
  }

  /** Hydrate column visibility + order from stored user preferences. */
  private initColumns(): void {
    // Must run before applyPreferences so a pre-WB-7903 layout is read under
    // the new keys rather than being discarded as stale.
    this.tablePrefs.renameKeysOnce(
      SideBySideCorrectionPanelComponent.THIS_TABLE_KEY,
      SideBySideCorrectionPanelComponent.RENAMED_KEYS,
      'wb7903_align_side_by_side_column_keys'
    );
    const stored = this.tablePrefs.applyPreferences(
      SideBySideCorrectionPanelComponent.THIS_TABLE_KEY,
      this.buildDefaultColumnSettings()
    );
    stored.forEach((column) => this.applyVisibility(column));
    this.columnOrder = this.pinnedFirst(stored.map((column) => column.key as ColumnKey));
    this.pickerColumns = this.buildPickerColumns(this.columnOrder);
    this.recomputeGridOrder();
  }

  /** Emitted by <ui-table-column-settings> on reorder / show / hide. */
  onColumnsChange(columns: ITableColumnSetting[]): void {
    // Only persist columns whose visibility actually changed here — columns
    // the user didn't touch (e.g. a pure reorder, or an untouched column
    // carried along in this emission) must keep falling through to the
    // computed default so a company-level setting change still applies later.
    const changedVisibility: Record<string, boolean> = {};
    columns.forEach((column) => {
      const key = column.key as ColumnKey;
      const wasVisible = this.columns[key]?.visible;
      const nowVisible = column.hideable === false ? true : column.visible;
      if (wasVisible !== nowVisible) {
        changedVisibility[key] = nowVisible;
      }
      this.applyVisibility(column);
    });
    this.columnOrder = this.pinnedFirst(columns.map((column) => column.key as ColumnKey));
    this.pickerColumns = columns;
    this.recomputeGridOrder();
    this.tablePrefs.save(SideBySideCorrectionPanelComponent.THIS_TABLE_KEY, columns, changedVisibility);
  }

  private applyVisibility(column: ITableColumnSetting): void {
    const target = this.columns[column.key as ColumnKey];
    if (target) target.visible = column.hideable === false ? true : column.visible;
  }

  /**
   * Register the current product custom field definitions as columns, dropping
   * any that no longer exist. New ones default to hidden (WB-7619).
   */
  private syncCustomFieldColumns(columns: IProductCustomFieldColumn[]): void {
    this.customFieldColumns.forEach((_, key) => {
      if (!columns.some((column) => column.key === key)) {
        delete this.columns[key];
      }
    });
    this.customFieldColumns = new Map(columns.map((column) => [column.key, column]));
    columns.forEach((column) => {
      const existing = this.columns[column.key];
      this.columns[column.key] = {
        label: column.label,
        rawLabel: true,
        visible: existing?.visible ?? false,
      };
    });
  }

  /** Column keys in table order: the hardcoded set, then the custom field ones. */
  private get allColumnKeys(): ColumnKey[] {
    return [...SideBySideCorrectionPanelComponent.DEFAULT_ORDER, ...this.customFieldColumns.keys()];
  }

  isCustomFieldColumn(key: ColumnKey): boolean {
    return this.customFieldColumns.has(key as ProductCustomFieldColumnKey);
  }

  /** Header text for a custom field column — already resolved, not an i18n key. */
  customFieldColumnLabel(key: ColumnKey): string {
    return this.customFieldColumns.get(key as ProductCustomFieldColumnKey)?.label ?? '';
  }

  /** Resolved cell content for a custom field column, or null when the column is unknown. */
  customFieldCell(item: IParseProduct, key: ColumnKey): IProductCustomFieldCell | null {
    const column = this.customFieldColumns.get(key as ProductCustomFieldColumnKey);
    if (!column) return null;
    return this.productCustomFieldColumns.cell(column, item?.custom_fields);
  }

  private buildDefaultColumnSettings(): ITableColumnSetting[] {
    return this.allColumnKeys.map((key) => {
      const setting = this.toColumnSetting(key);
      // Company default only — applyPreferences still lets a stored user
      // preference override this, so users who chose to show them keep them.
      if (this.hidePricingColumns && SideBySideCorrectionPanelComponent.PRICING_KEYS.has(key)) {
        setting.visible = false;
      }
      return setting;
    });
  }

  private buildPickerColumns(order: ColumnKey[]): ITableColumnSetting[] {
    return order.map((key) => this.toColumnSetting(key));
  }

  /**
   * When the company "hide pricing columns" setting is on, pricing columns
   * become hideable even if normally locked, so users can manage them.
   */
  private isHideable(key: ColumnKey): boolean {
    if (this.hidePricingColumns && SideBySideCorrectionPanelComponent.PRICING_KEYS.has(key)) {
      return true;
    }
    return !SideBySideCorrectionPanelComponent.NON_HIDEABLE_KEYS.has(key);
  }

  private toColumnSetting(key: ColumnKey): ITableColumnSetting {
    // Custom field columns can disappear between two hydrations (definition
    // deleted in settings), so never assume the config is still registered.
    const config = this.columns[key] as IColumnConfig | undefined;
    return {
      key,
      label: config?.pickerLabel ?? config?.label ?? key,
      visible: !!config?.visible,
      pinned: SideBySideCorrectionPanelComponent.PINNED_KEYS.has(key),
      hideable: this.isHideable(key),
    };
  }

  private pinnedFirst(keys: ColumnKey[]): ColumnKey[] {
    const pinned = keys.filter((key) => SideBySideCorrectionPanelComponent.PINNED_KEYS.has(key));
    const rest = keys.filter((key) => !SideBySideCorrectionPanelComponent.PINNED_KEYS.has(key));
    return [...pinned, ...rest];
  }

  private recomputeGridOrder(): void {
    const index: Partial<Record<ColumnKey, number>> = {};
    this.orderedColumns.forEach((key, i) => (index[key] = i + 1));
    this.gridOrderIndex = index;
  }

  getDeliveryDateInputValue(product: IParseProduct): Date | null {
    const raw = product?.delivery_date as string | Date | undefined;
    if (!raw) return null;
    const date = raw instanceof Date ? raw : new Date(raw);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  onDeliveryDateChange(event: MatDatepickerInputEvent<Date>, product: IParseProduct): void {
    product = this.liveRow(product);
    const date = event.value;
    if (!date) {
      product.delivery_date = '';
      return;
    }
    // Keep payload-friendly format (YYYY-MM-DD).
    // FIXME(pre-existing, out of scope for WB-7478): `toISOString()` converts to UTC
    // before slicing, so a user east of Greenwich picking a date before their offset
    // (e.g. 00:30 at UTC+2) stores the PREVIOUS day. The order-level shipping date was
    // fixed via `toLocalIsoDate()`; these per-line delivery dates still need the same
    // treatment. Deliberately left as-is to keep this branch scoped.
    product.delivery_date = date.toISOString().slice(0, 10);
  }

  productState(product: IParseProduct): string {
    if(product.has_alternatives) {
      return 'review';
    }
    if(product.matched) {
      return 'manual';
    }
    return 'ai-matched';
  }

  matchMethodBadge(product: IParseProduct): { labelKey: string; valueLabelKey: string; value: string } | null {
    const method = (product.ai_match_method || '').toLowerCase();
    const value = (product.ai_match_value || '').trim();
    if (!method || !value) return null;

    if (method === 'exact_alias') {
      return {
        labelKey: 'quotations_and_orders.match_method.perfect_alias',
        valueLabelKey: 'quotations_and_orders.match_method.alias_value',
        value,
      };
    }
    if (method === 'exact_code') {
      const field = (product.ai_match_field || '').toLowerCase();
      const fieldToLabel: Record<string, string> = {
        sku: 'quotations_and_orders.match_method.sku_value',
        ean: 'quotations_and_orders.match_method.ean_value',
        extra_identifier: 'quotations_and_orders.match_method.extra_identifier_value',
        external_reference: 'quotations_and_orders.match_method.external_ref_value',
      };
      const valueLabelKey = fieldToLabel[field] || 'quotations_and_orders.match_method.extra_identifier_value';
      return {
        labelKey: 'quotations_and_orders.match_method.perfect_code',
        valueLabelKey,
        value,
      };
    }
    if ((method === 'preferred' || method === 'preferred_global') && /^\d+$/.test(value)) {
      return {
        labelKey: 'quotations_and_orders.match_method.preferred',
        valueLabelKey: method === 'preferred_global'
          ? 'quotations_and_orders.match_method.frequency_value_global'
          : 'quotations_and_orders.match_method.frequency_value',
        value,
      };
    }
    return null;
  }

  getProductStatusIcon(product: IParseProduct): string {
    if (product.matched || product.added_manually) return 'manual-match-icon';
    if (this.isPreferredProductMatch(product)) return 'preferred-match-icon';
    if (product.has_alternatives) return 'check-list-icon';
    return 'check-icon';
  }

  isPreferredProductMatch(product: IParseProduct): boolean {
    const method = (product.ai_match_method || '').toLowerCase();
    const value = (product.ai_match_value || '').trim();
    return (method === 'preferred' || method === 'preferred_global') && /^\d+$/.test(value);
  }

  getProductMatchTooltip(product: IParseProduct): string {
    if (product.added_manually) {
      return this.translateService.instant('quotations_and_orders.match_method.tooltip_manually_added');
    }
    if (product.matched) {
      return this.translateService.instant('quotations_and_orders.match_method.tooltip_manually_matched');
    }
    const badge = this.matchMethodBadge(product);
    if (badge) {
      const label = this.translateService.instant(badge.labelKey);
      const valueLabel = this.translateService.instant(badge.valueLabelKey);
      return `${label} — ${valueLabel}: ${badge.value}`;
    }
    if (product.has_alternatives) {
      return this.translateService.instant('quotations_and_orders.match_method.tooltip_review_alternatives');
    }
    return this.translateService.instant('quotations_and_orders.match_method.tooltip_ok');
  }

  openMatchSingleOrderLineProduct(product: IParseProduct, event: Event, isUnmatched: boolean = false): void {
    event?.stopPropagation();

    // `product` is emitted by the `combinedLines` getter, which returns fresh spread
    // copies on every change-detection cycle. Resolve the actual stored row by its
    // stable key so the reference-based updates below land on the rendered array
    // (otherwise indexOf/includes never match the copy and nothing updates).
    const rowKey = this.getRowKey(product);
    const matchedTarget = this.products.find((p) => this.getRowKey(p) === rowKey);
    const unmatchedTarget = this.unmatchedProducts.find((p) => this.getRowKey(p) === rowKey);
    const target = matchedTarget ?? unmatchedTarget ?? product;
    const isUnmatchedSource = !!unmatchedTarget;

    // Open the inline matching editor over the products tab (replaces the modal).
    this.matchTarget = target;
    this.matchMatchedTarget = matchedTarget;
    this.matchIsUnmatchedSource = isUnmatchedSource;
    this.matchSelectorData = {
      mode: 'side_by_side',
      quotationId: this.quotation?.id,
      isUnmatched,
      products: [target],
      quoteProducts: this.displayedProducts || [],
      orderCustomerId: this.quotation?.location?.id_company,
    };
    // Capture before the flag flips: the overlay's *ngIf destroys the viewport this reads from.
    this.saveProductsScrollPosition();
    this.productMatchEditMode = true;
    // WB-7483: pin this line's doc coordinates for the whole edit. The row hover that opened the
    // editor leaves `activeLineKey` set (the table unmounts without firing mouseleave), so clear the
    // hover tiers too — the pinned key alone drives the highlight now, and nothing stale survives
    // the unlock.
    this.lockedLineKey = this.getRowKey(target);
    this.activeLineKey = null;
    this.activeField = null;
    this.revealBodyForTextAnchor();
  }

  onMatchSelectorCancelled(): void {
    this.productMatchEditMode = false;
    this.unlockDocHighlight();
    this.restoreProductsScrollPosition();
  }

  onMatchSelectorCompleted(result: any): void {
    this.productMatchEditMode = false;
    this.unlockDocHighlight();
    // Before the early returns below, so every completion path (match, ignore, no-op) restores.
    this.restoreProductsScrollPosition();

    const target = this.matchTarget;
    const matchedTarget = this.matchMatchedTarget;
    const isUnmatchedSource = this.matchIsUnmatchedSource;
    if (!target) return;

      // Handle ignore action (D-12, D-13)
      if (result?.action === 'ignore') {
        const unmatchedLineId = target._unmatchedLineId ?? target.id;
        this.ignoreUnmatched = [...this.ignoreUnmatched, {
          unmatched_line_id: unmatchedLineId as number,
          code: result.code,
          extracted_name: result.extracted_name,
        }];
        // Remove from unmatchedProducts for immediate UI feedback (D-13)
        this.unmatchedProducts = this.unmatchedProducts.filter(p => p !== target);
        return;
      }

      const selected = result?.selectedProduct as IProduct | undefined;
      if (!selected?.id) return;

      // Stamp per-line intent on the row; undefined rows fall back to the
      // payload-level default when the batch is saved.
      const perLineIntent: CorrectionIntent | undefined = result.alwaysMatch ? 'permanent' : undefined;
      const perLineAmtwCode: string | null = result.amtwCode ?? null;

      this.rememberRollbackSnapshot(target);
      const updated: IParseProduct = {
        ...this.buildReplacedProduct(target, selected, { preferDefaultHandlingUnit: isUnmatchedSource }),
        _correctionIntent: perLineIntent,
        _amtwCode: perLineAmtwCode,
      };
      this.ensureRowKey(updated, matchedTarget ? 'prod' : 'new');
      const idx = this.products.indexOf(target);
      if (idx !== -1) {
        const next = [...this.products];
        next[idx] = updated;
        this.products = next;
        return;
      }

      const unmatchedIdx = this.unmatchedProducts.indexOf(target);
      if (unmatchedIdx !== -1) {
        const unmatchedLineId = target._unmatchedLineId ?? target.id;

        const matchedInPlace: IParseProduct = {
          ...updated,
          _matchedAsNew: true,
          _unmatchedLineId: unmatchedLineId,
          _correctionIntent: perLineIntent,
          _amtwCode: perLineAmtwCode,
        };
        this.ensureRowKey(matchedInPlace, 'unmatched');

        const nextUnmatched = [...this.unmatchedProducts];
        nextUnmatched[unmatchedIdx] = matchedInPlace;
        this.unmatchedProducts = nextUnmatched;

        const matchEntry = this.buildMatchUnmatchedEntry(matchedInPlace);
        if (matchEntry) this.upsertMatchUnmatched(matchEntry);
      }
  }

  private buildReplacedProduct(
    previous: IParseProduct,
    selected: IProduct,
    options?: { preferDefaultHandlingUnit?: boolean }
  ): IParseProduct {
    const id = (selected.id ?? selected.product_id ?? previous.id) as number;
    const product_id = (selected.id ?? selected.product_id ?? previous.product_id) as number;
    const inheritedQtyHu = Number(previous.quantity_handling_unit ?? previous.quantity ?? 0) || 0;

    const currencyPrices = this.getProductPricesForQuotationCurrency(selected);
    const price_unit = selected.currencies && selected.currencies.length > 0 ? (currencyPrices.final_price ?? currencyPrices.sales_price ?? 0) : selected.sales_price as any;
    const discount = (selected.discount ?? previous.discount ?? 0) as any;

    const selectedHandlingUnits = ((selected.handling_units as any) || []) as IProductHandlingUnit[];
    const defaultUnit = selectedHandlingUnits.find((u) => (u as any).default) || selectedHandlingUnits[0];
    const previousUnitTypeId = this.getSelectedHandlingUnit(previous)?.type_id;
    const inheritedUnit = previousUnitTypeId
      ? selectedHandlingUnits.find((u) => u.type_id === previousUnitTypeId)
      : undefined;

    const chosenUnit = options?.preferDefaultHandlingUnit ? defaultUnit : inheritedUnit;
    const inheritedRequiresSelection = !chosenUnit && selectedHandlingUnits.length > 0;
    const handlingUnitQty = handlingUnitBaseMultiplier(chosenUnit);
    const baseUnit = selectedHandlingUnits.find(u => u.is_base_unit);
    const quantity = applyHandlingUnitRounding(inheritedQtyHu * handlingUnitQty, baseUnit);

    // Preserve the user's price choice: matching only updates system price (catalog_price)
    const previousPriceType = previous.price_type ?? 'catalog';
    let finalPrice: number;
    if (previousPriceType === 'catalog') {
      finalPrice = Number(price_unit) || 0;
    } else {
      finalPrice = Number(previous.final_price) || Number(price_unit) || 0;
    }
    const total = finalPrice * (Number(quantity) || 0);

    const replaced: any = {
      ...previous,
      id,
      product_id,
      name: selected.name ?? previous.name,
      sku: selected.sku ?? previous.sku,
      image: selected.image ?? previous.image,
      description: selected.description ?? previous.description,
      increment: selected.increment ?? previous.increment,
      min_qte: selected.min_qte ?? previous.min_qte,
      max_qte: selected.max_qte ?? previous.max_qte,
      quantity,
      quantity_handling_unit: inheritedQtyHu,
      price_unit,
      catalog_price: price_unit,
      final_price: finalPrice,
      ai_price: previous.ai_price ?? null,
      price_type: previousPriceType,
      sales_price: (currencyPrices.sales_price) as any,
      cost: (currencyPrices.cost) as any,
      discount,
      total,
      matched: true,
      alternatives: [],
      handling_units: selectedHandlingUnits,
      handling_unit_id: chosenUnit?.id,
      ...(inheritedRequiresSelection ? { handling_unit_quantity: 1 } : { handling_unit_quantity: handlingUnitQty }),
    };
    replaced.requires_handling_unit_selection = inheritedRequiresSelection;
    return replaced as IParseProduct;
  }

  /** Sentinel `mat-option` value that opens the create-selling-unit modal instead of selecting a unit. */
  readonly HU_CREATE_SENTINEL = '__create_selling_unit__';

  getHandlingUnits(product: IParseProduct): IProductHandlingUnit[] {
    const units = (product?.handling_units || []) as IProductHandlingUnit[];
    return units;
  }

  getSelectedHandlingUnit(product: IParseProduct): IProductHandlingUnit | undefined {
    const units = this.getHandlingUnits(product);
    const selectedId = product?.handling_unit_id;
    if (selectedId !== null && selectedId !== undefined) {
      const byId = units.find((u) => u.id === selectedId);
      if (byId) return byId;
    }
    if ((product as any)?.requires_handling_unit_selection) return undefined;
    return units.find((u) => (u as any).default) || units[0];
  }

  /** @see quantityInBaseUnitsTranslationParams */
  quantityInBaseUnitsExplainParams(product: IParseProduct): {
    sellingQty: string;
    multiplier: string;
    baseUnits: string;
  } {
    const baseUnit = this.getHandlingUnits(product).find(u => u.is_base_unit);
    return quantityInBaseUnitsTranslationParams(product.quantity_handling_unit, this.getSelectedHandlingUnit(product), baseUnit);
  }

  selectedHandlingUnitHasConversion(product: IParseProduct): boolean {
    return handlingUnitHasConversion(this.getSelectedHandlingUnit(product));
  }

  requiresHandlingUnitSelection(product: IParseProduct): boolean {
    return !!(product as any)?.requires_handling_unit_selection && !product?.handling_unit_id;
  }

  onHandlingUnitQtyInput(event: Event, product: IParseProduct): void {
    product = this.liveRow(product);
    const input = event.target as HTMLInputElement | null;
    const raw = input?.value ?? '';
    const qtyHu = raw === '' ? 0 : Number(raw);

    const safeQtyHu = Number.isFinite(qtyHu) && qtyHu >= 0 ? qtyHu : 0;
    const unit = this.getSelectedHandlingUnit(product);
    const unitQty = handlingUnitBaseMultiplier(unit);

    const baseUnit = this.getHandlingUnits(product).find(u => u.is_base_unit);
    const quantity = applyHandlingUnitRounding(safeQtyHu * unitQty, baseUnit);
    // Mutate in place to avoid losing input focus (re-render).
    product.quantity_handling_unit = safeQtyHu;
    product.quantity = quantity;
    (product as any).handling_unit_quantity = unitQty;
    product.total = (Number(product.price_unit) || 0) * quantity;
    this.syncMatchUnmatchedIfNeeded(product);
  }

  onMatchedUnmatchedDeliveryDateChange(event: MatDatepickerInputEvent<Date>, product: IParseProduct): void {
    product = this.liveRow(product);
    const date = event.value;
    // FIXME(pre-existing, out of scope for WB-7478): `toISOString()` converts to UTC
    // before slicing, so a user east of Greenwich picking a date before their offset
    // (e.g. 00:30 at UTC+2) stores the PREVIOUS day. The order-level shipping date was
    // fixed via `toLocalIsoDate()`; these per-line delivery dates still need the same
    // treatment. Deliberately left as-is to keep this branch scoped.
    const deliveryDate = date ? date.toISOString().slice(0, 10) : '';
    product.delivery_date = deliveryDate;
    this.syncMatchUnmatchedIfNeeded(product);
  }

  openLineNotesDialog(product: IParseProduct): void {
    const row = this.liveRow(product);
    const editable = !this.viewMode;
    this.dialog
      .open(ProductNotesDialogComponent, {
        data: {
          productName: row.name,
          note: row.notes ?? '',
          editable,
        },
      })
      .afterClosed()
      .subscribe((result: IProductNotesDialogResult | undefined) => {
        // Mutate the live row only; the panel's Save button batches all line edits.
        // Dispatching here would trigger UpdateQuotationLinesSuccess and close the panel.
        if (!result || !editable) return;
        if ((row.notes ?? '') === result.note) return;
        row.notes = result.note;
      });
  }

  editCustomFields(): void {
    this.dialog.open(OrderCustomFieldsComponent, {
      data: {
        objectCustomFields: this.objectCustomFields,
      },
    }).afterClosed().subscribe((result: IObjectCustomFields['values'] | undefined) => {
      if (result) {
        this.saveOrderCustomFields(result);
      }
    });
  }

  saveOrderCustomFields(values: IObjectCustomFields['values']): void {
    this.store.dispatch(
      UpdateObjectCustomFields({
        params: { ...this.objectCustomFieldsParams },
        values,
      })
    );
  }

  private upsertMatchUnmatched(entry: IMatchUnmatchedItem): void {
    const existingIdx = this.matchUnmatched.findIndex((m) => m.unmatched_line_id === entry.unmatched_line_id);
    if (existingIdx !== -1) {
      const next = [...this.matchUnmatched];
      next[existingIdx] = { ...next[existingIdx], ...entry };
      this.matchUnmatched = next;
    } else {
      this.matchUnmatched = [...this.matchUnmatched, entry];
    }
  }

  /**
   * Build the match_unmatched payload entry for a matched-as-new row, carrying the
   * handling-unit selection and the (possibly edited) unit price alongside the
   * resulting base quantity. Only defined fields are included so a partial update
   * (e.g. just the delivery date) doesn't clobber previously-set values on merge.
   */
  private buildMatchUnmatchedEntry(product: IParseProduct): IMatchUnmatchedItem | null {
    const unmatchedLineId = product._unmatchedLineId ?? product.id;
    const productId = product.product_id ?? product.id;
    if (unmatchedLineId == null || productId == null) return null;

    return {
      unmatched_line_id: unmatchedLineId as number,
      product_id: productId as number,
      quantity: Number(product.quantity) || 0,
      ...(product.quantity_handling_unit != null ? { quantity_handling_unit: Number(product.quantity_handling_unit) || 0 } : {}),
      ...(product.handling_unit_id != null ? { handling_unit_id: product.handling_unit_id } : {}),
      ...(typeof product.delivery_date === 'string' ? { delivery_date: product.delivery_date } : {}),
      ...(product.final_price != null ? { final_price: Number(product.final_price) || 0 } : {}),
      ...(product.price_type ? { price_type: product.price_type } : {}),
      ...(product._correctionIntent ? { correction_intent: product._correctionIntent } : {}),
      ...(product._amtwCode ? { amtw_code: product._amtwCode } : {}),
    };
  }

  /** Sync a matched-as-new row's edits (qty / handling unit / price / date) into the match_unmatched payload. */
  private syncMatchUnmatchedIfNeeded(product: IParseProduct): void {
    if (!product._matchedAsNew) return;
    const entry = this.buildMatchUnmatchedEntry(product);
    if (entry) this.upsertMatchUnmatched(entry);
  }

  /**
   * Resolve a row to the live object stored in `products` / `newProducts` /
   * `unmatchedProducts` rather than the shallow copy `combinedLines` hands the template.
   * Edit handlers must mutate the stored object, otherwise the change lives only on the
   * throwaway copy: `this.products` stays untouched, so `hasLineChanges()` reports nothing,
   * `save()` dispatches nothing, and closing the panel skips the discard prompt. Keys are
   * namespaced (`ol:` / `new:` / `unmatched:`) so the lookup order can't cross-match.
   */
  private liveRow(product: IParseProduct): IParseProduct {
    const key = this.getRowKey(product);
    return (
      this.products.find((p) => this.getRowKey(p) === key) ??
      this.newProducts.find((p) => this.getRowKey(p) === key) ??
      this.unmatchedProducts.find((p) => this.getRowKey(p) === key) ??
      product
    );
  }

  onHandlingUnitChange(event: MatSelectChange, product: IParseProduct): void {
    const row = this.liveRow(product);
    if (event?.value === this.HU_CREATE_SENTINEL) {
      // Not a real unit: revert the control to the current selection and open the modal.
      if (event.source) {
        event.source.value = row.handling_unit_id ?? null;
      }
      this.openCreateSellingUnit(product);
      return;
    }
    this.applyHandlingUnitSelection(row, event?.value as number);
  }

  /** Apply a handling-unit selection to a (live) row: recompute qty/total and sync the match payload. */
  private applyHandlingUnitSelection(product: IParseProduct, selectedId: number): void {
    const units = this.getHandlingUnits(product);
    const selectedUnit = units.find((u) => u.id === selectedId) || units[0];
    if (!selectedUnit) return;
    const unitQty = handlingUnitBaseMultiplier(selectedUnit);

    const qtyHu = Number(product.quantity_handling_unit);
    const safeQtyHu = Number.isFinite(qtyHu) && qtyHu >= 0
      ? qtyHu
      : this.deriveQuantityHandlingUnit(product.quantity, unitQty);

    const baseUnit = units.find(u => u.is_base_unit);
    const quantity = applyHandlingUnitRounding(safeQtyHu * unitQty, baseUnit);
    // Mutate in place to avoid losing input focus (re-render).
    product.handling_unit_id = selectedUnit.id;
    product.quantity_handling_unit = safeQtyHu;
    product.quantity = quantity;
    (product as any).handling_unit_quantity = unitQty;
    (product as any).requires_handling_unit_selection = false;
    product.total = (Number(product.price_unit) || 0) * quantity;
    this.syncMatchUnmatchedIfNeeded(product);
  }

  /**
   * Shortcut for WB-5818: create a Volta-managed selling unit for this line's product from inside
   * the correction panel. Reuses the existing inventory modal; on success re-fetches the product's
   * handling units (the PUT only returns a message + id) and auto-selects the newly created unit.
   * Mutates the live row only — no quotation dispatch, so the panel stays open and batches the save.
   */
  openCreateSellingUnit(product: IParseProduct): void {
    const row = this.liveRow(product);
    const productTemplateId = (row.product_template_id ?? row.product_id) as number | undefined;
    const productId = (row.product_id ?? row.id) as number | undefined;
    if (productId == null) return;
    const prevIds = new Set((row.handling_units ?? []).map((u) => u.id));

    this.dialog
      .open(HandlingUnitsDialogueComponent, {
        data: { productVariantId: productId, existingUnits: row.handling_units },
        disableClose: true,
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((created: boolean) => {
        if (!created) return;
        if (productTemplateId == null) return;
        this.productsService.getProductInventoryDetails(productTemplateId)
          .pipe(takeUntil(this.destroy$))
          .subscribe((res) => {
            const units = this.handlingUnitsFromInventory(res?.object, productId);
            row.handling_units = units;
            const newUnit = units.find((u) => !prevIds.has(u.id));
            if (newUnit) {
              this.applyHandlingUnitSelection(row, newUnit.id);
            }
          });
      });
  }

  /** Pick the handling units for `productId` from an inventory-details response (variant-aware). */
  private handlingUnitsFromInventory(details: IProductInventoryDetails | undefined, productId: number): IProductHandlingUnit[] {
    if (!details) return [];
    const variant = details.variants?.find((v) => v.product_id === productId);
    return (variant?.handling_units ?? details.handling_units ?? []) as IProductHandlingUnit[];
  }

  trackByProduct = (_: number, product: IParseProduct): number | string => {
    return this.getRowKey(product);
  }

  get combinedLines(): Array<IParseProduct & { _isUnmatched?: boolean }> {
    const matched = this.products.map(p => ({ ...p, _isUnmatched: false as const }));
    const unmatched = (this.unmatchedProducts || []).map(p => ({ ...p, _isUnmatched: true as const }));
    return [...matched, ...unmatched].sort((a, b) => (a.sequence ?? 999999) - (b.sequence ?? 999999));
  }

  // ---------------------------------------------------------------------------
  // WB-8278 — group lines by resolution status
  // ---------------------------------------------------------------------------

  /** Mode + collapse state + bucketing, shared with the order detail page's product list. */
  readonly grouping = new LineGroupingController();

  get lineGroupingMode(): LineGroupingMode {
    return this.grouping.mode;
  }

  onLineGroupingModeChange(mode: LineGroupingMode): void {
    if (!this.grouping.setMode(mode)) return;
    // Grouping a partially-loaded list hides rows that belong at the top: an unmatched line sitting
    // on page 4 would stay invisible in exactly the many-line orders this feature targets. Kick the
    // background page chain here rather than on open, so the default view keeps its lazy loading.
    if (mode === 'resolution') this.maybeAutoLoadRemainingLines();
  }

  isLineGroupCollapsed(key: LineMatchGroup): boolean {
    return this.grouping.isCollapsed(key);
  }

  toggleLineGroup(key: LineMatchGroup): void {
    this.grouping.toggle(key);
  }

  /**
   * `newProducts` (added in this session, not yet persisted) fold into `matched`: they are resolved
   * by definition, and in grouped mode the separate "newly added" divider would compete with the
   * group headers. The default mode still renders them under that divider.
   *
   * Note the spread: grouped mode hands the template shallow copies of `newProducts`, where the
   * default mode renders the live objects. Safe because every edit handler resolves its argument
   * back to the stored row through `liveRow()` before touching it — an edit applied to a copy here
   * would be silently lost on save, exactly as it would for the `combinedLines` copies alongside.
   */
  get groupedLines(): LineGroupView[] {
    return this.grouping.groups(
      () => [
        ...this.combinedLines,
        ...(this.newProducts || []).map(p => ({ ...p, _isUnmatched: false as const })),
      ],
      [
        this.products, this.products.length,
        this.newProducts, this.newProducts?.length ?? 0,
        this.unmatchedProducts, this.unmatchedProducts?.length ?? 0,
      ],
    );
  }

  trackByLineGroup = this.grouping.trackByGroup;

  canRollBack(product: IParseProduct): boolean {
    return this.rollbackSnapshots.has(this.getRowKey(product));
  }

  rollBackProduct(product: IParseProduct): void {
    const key = this.getRowKey(product);
    const snapshot = this.rollbackSnapshots.get(key);
    if (!snapshot) return;

    const restored = this.deepClone(snapshot);

    // `product` may be a `combinedLines` spread copy, so locate rows by stable key
    // rather than object reference (indexOf would never match the copy).
    const idx = this.products.findIndex((p) => this.getRowKey(p) === key);
    const newIdx = this.newProducts.findIndex((p) => this.getRowKey(p) === key);
    const unmatchedIdx = this.unmatchedProducts.findIndex((p) => this.getRowKey(p) === key);

    this.ensureRowKey(restored, idx !== -1 ? 'prod' : unmatchedIdx !== -1 ? 'unmatched' : 'new');

    if (idx !== -1) {
      const next = [...this.products];
      next[idx] = restored;
      this.products = next;
      this.rollbackSnapshots.delete(key);
      return;
    }

    if (newIdx !== -1) {
      const next = [...this.newProducts];
      next[newIdx] = restored;
      this.newProducts = next;
      this.rollbackSnapshots.delete(key);
      return;
    }

    if (unmatchedIdx !== -1) {
      const next = [...this.unmatchedProducts];
      next[unmatchedIdx] = restored;
      this.unmatchedProducts = next;
      const unmatchedLineId = product._unmatchedLineId;
      if (unmatchedLineId != null) {
        this.matchUnmatched = this.matchUnmatched.filter((m) => m.unmatched_line_id !== unmatchedLineId);
      }
      this.rollbackSnapshots.delete(key);
    }
  }

  private rememberRollbackSnapshot(product: IParseProduct): void {
    const key = this.getRowKey(product);
    if (this.rollbackSnapshots.has(key)) return;
    this.rollbackSnapshots.set(key, this.deepClone(product));
  }

  private getRowKey(product: IParseProduct): string {
    if (product?.order_line_id !== null && product?.order_line_id !== undefined) {
      return `ol:${product.order_line_id}`;
    }
    const existing = (product as any).__sbsRowKey as string | undefined;
    if (existing) return existing;
    return `tmp:${product.id ?? product.product_id ?? product.name}`;
  }

  private ensureRowKey(product: IParseProduct, prefix: 'prod' | 'new' | 'unmatched'): void {
    if (!product) return;
    if (product.order_line_id !== null && product.order_line_id !== undefined) return;
    if ((product as any).__sbsRowKey) return;
    (product as any).__sbsRowKey = `${prefix}:${this.tempKeySeq++}`;
  }

  private deepClone<T>(value: T): T {
    // Product DTOs are plain objects; JSON cloning is sufficient here.
    return JSON.parse(JSON.stringify(value)) as T;
  }

  startAddProduct(): void {
    this.isAddProductMode = true;
    this.addProductQuery = '';
    this.store.dispatch(ClearProducts());
    setTimeout(() => {
      this.addProductInput?.nativeElement?.focus();
      this.addProductAutoTrigger?.openPanel();
    });
  }

  cancelAddProduct(): void {
    this.isAddProductMode = false;
    this.addProductQuery = '';
    this.store.dispatch(ClearProducts());
  }

  onSearch(event: Event): void {
    const value = (event.target as HTMLInputElement).value || '';
    this.addProductQuery = value;

    if (!value || value.length < 1) {
      this.store.dispatch(ClearProducts());
      this.isSearchLoading = false;
      return;
    }

    this.searchPage = 1;
    this.isSearchLoading = true;
    const filterRequest = {
      filters: [
        {
          key: 'status',
          operator: 'equals',
          value: "Published"
        }
      ]
    };
    this.store.dispatch(
      FetchProductsBySearch({
        keyword: value,
        filter: filterRequest,
        includeDeals: false,
        page: { number: 1, size: 10 },
        append: false,
        skipGlobalLoader: true
      })
    );
  }

  loadMoreProducts(): void {
    if (this.isLoadingMore || !this.addProductQuery) return;
    if (!this.searchMetadata || this.searchPage >= this.searchMetadata.pages) return;

    this.isLoadingMore = true;
    this.isSearchLoading = true;
    this.searchPage++;
    const filterRequest = {
      filters: [
        {
          key: 'status',
          operator: 'equals',
          value: "Published"
        }
      ]
    };
    this.store.dispatch(
      FetchProductsBySearch({
        keyword: this.addProductQuery,
        filter: filterRequest,
        includeDeals: false,
        page: { number: this.searchPage, size: 10 },
        append: true,
        skipGlobalLoader: true
      })
    );
  }

  onAutocompleteOpened(): void {
    setTimeout(() => {
      const panel = this.addProductAutoTrigger?.autocomplete?.panel?.nativeElement;
      if (panel) {
        panel.addEventListener('scroll', this.onPanelScroll);
      }
    });
  }

  onAutocompleteClosed(): void {
    this.removePanelScrollListener();
  }

  onPanelScroll = (): void => {
    const panel = this.addProductAutoTrigger?.autocomplete?.panel?.nativeElement;
    if (!panel) return;
    const threshold = 50;
    const atBottom = panel.scrollHeight - panel.scrollTop - panel.clientHeight < threshold;
    if (atBottom && !this.isLoadingMore) {
      this.loadMoreProducts();
    }
  };

  private removePanelScrollListener(): void {
    const panel = this.addProductAutoTrigger?.autocomplete?.panel?.nativeElement;
    if (panel) {
      panel.removeEventListener('scroll', this.onPanelScroll);
    }
  }

  onAddProductOptionSelected(event: MatAutocompleteSelectedEvent): void {
    const selected = event.option.value as IProduct;
    this.addProduct(selected);
  }

  onAddProductKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Tab') return;
    if (!this.addProductAutoTrigger?.panelOpen) return;

    const km = (this.addProductAutoTrigger.autocomplete as any)?._keyManager;
    const active = km?.activeItem;
    const selected = active?.value as IProduct | undefined;
    if (!selected) return;

    event.preventDefault();
    this.addProduct(selected);
  }

  private addProduct(selected: IProduct): void {
    const newProductId = (selected.product_id ?? selected.id) as number | undefined;
    if (!newProductId) return;
    const qtyHu = (selected.min_qte ?? 1) as number;
    const currencyPrices = this.getProductPricesForQuotationCurrency(selected);
    const unitPrice = (currencyPrices.final_price ?? currencyPrices.sales_price ?? 0) as number;
    const base: IParseProduct = {
      id: (selected.id ?? selected.product_id ?? newProductId) as number,
      product_id: newProductId,
      name: selected.name,
      sku: selected.sku,
      // Carried so the replaced line renders the tenant's primary code, not a
      // stale fallback to SKU (WB-7419).
      erp_id: selected.erp_id,
      quantity: 0,
      quantity_handling_unit: qtyHu,
      discount: (selected.discount ?? 0) as any,
      cost: (currencyPrices.cost) as any,
      sales_price: (currencyPrices.sales_price) as any,
      price_unit: unitPrice as any,
      final_price: unitPrice as any,
      catalog_price: unitPrice as any,
      ai_price: null,
      price_type: 'catalog',
      total: 0,
      image: selected.image,
      description: selected.description as any,
      increment: selected.increment as any,
      max_qte: selected.max_qte as any,
      min_qte: selected.min_qte as any,
      matched: true,
      handling_units: (selected.handling_units as any) || [],
      handling_unit_id: undefined,
      delivery_date: this.orderDeliveryDate || undefined,
    };

    const normalized = this.normalizeProductHandlingUnits(base);
    const unitQty = handlingUnitBaseMultiplier(this.getSelectedHandlingUnit(normalized));
    const baseUnit = this.getHandlingUnits(normalized).find(u => u.is_base_unit);
    normalized.quantity = applyHandlingUnitRounding(qtyHu * unitQty, baseUnit);
    normalized.total = (Number(normalized.price_unit) || 0) * normalized.quantity;
    this.ensureRowKey(normalized, 'new');

    this.newProducts = [...(this.newProducts || []), normalized];
    this.cancelAddProduct();
    this.programmaticScrollPending = true;
    setTimeout(() => {
      const viewport = document.querySelector('.products-viewport-side-by-side');
      viewport?.scrollTo({ top: viewport.scrollHeight, behavior: 'smooth' });
    });
  }

  private getProductPricesForQuotationCurrency(product: IProduct): {
    sales_price?: number;
    final_price?: number;
    cost?: number;
  } {
    const quotationCurrencyId = this.quotation?.currency?.id;
    if (!quotationCurrencyId) {
      return {};
    }

    const currencyRow = (product.currencies || []).find((c) => c.currency_id === quotationCurrencyId);
    if (!currencyRow) {
      return {};
    }

    return {
      sales_price: currencyRow.sales_price,
      final_price: currencyRow.final_price,
      cost: currencyRow.cost,
    };
  }

  private normalizeProductHandlingUnits(product: IParseProduct): IParseProduct {
    const units = (product?.handling_units || []) as IProductHandlingUnit[];
    let normalizedUnits = units;

    const desiredHandlingUnitId =
      product?.handling_unit_id ??
      normalizedUnits.find((u) => (u as any).default)?.id ??
      normalizedUnits[0]?.id ??
      undefined;

    const selectedUnit =
      normalizedUnits.find((u) => u.id === desiredHandlingUnitId) ||
      normalizedUnits.find((u) => (u as any).default) ||
      normalizedUnits[0] ||
      undefined;

    const unitQty = handlingUnitBaseMultiplier(selectedUnit);
    const quantityHu =
      product.customer_order_unit?.quantity ??
      product.quantity_handling_unit ??
      this.deriveQuantityHandlingUnit(product.quantity, unitQty);

    const baseUnit = normalizedUnits.find(u => u.is_base_unit);
    const roundedQty = applyHandlingUnitRounding(quantityHu * unitQty, baseUnit);

    return {
      ...product,
      handling_units: normalizedUnits,
      handling_unit_id: selectedUnit?.id,
      quantity_handling_unit: quantityHu,
      quantity: roundedQty,
    };
  }

  private deriveQuantityHandlingUnit(quantity: number, unitQty: number): number {
    const q = Number(quantity);
    const u = Number(unitQty) || 1;
    if (!Number.isFinite(q) || q < 0) return 0;
    if (u <= 0) return q;
    return q / u;
  }

  isAllProductsSelected(): boolean {
    const total = this.displayedProducts.length + this.unmatchedProducts.length;
    return total > 0 && this.selectedRowKeys.size === total;
  }

  isPartialSelectedAll(): boolean {
    const total = this.displayedProducts.length + this.unmatchedProducts.length;
    return this.selectedRowKeys.size > 0 && this.selectedRowKeys.size < total;
  }

  toggleAllProducts(checked: boolean): void {
    if (checked) {
      this.selectedRowKeys.clear();
      [...this.displayedProducts, ...this.unmatchedProducts].forEach((p) => {
        this.selectedRowKeys.add(this.getRowKey(p));
      });
      return;
    }
    this.selectedRowKeys.clear();
  }

  isProductSelected(product: IParseProduct): boolean {
    return this.selectedRowKeys.has(this.getRowKey(product));
  }

  toggleProduct(product: IParseProduct, checked: boolean): void {
    const key = this.getRowKey(product);
    if (checked) this.selectedRowKeys.add(key);
    else this.selectedRowKeys.delete(key);
  }

  markAsGift(): void {
    if (this.selectedRowKeys.size === 0) return;

    const applyGift = (product: IParseProduct): IParseProduct => {
      if (!this.selectedRowKeys.has(this.getRowKey(product))) return product;
      return { ...product, is_gift: true };
    };

    this.products = this.products.map(applyGift);
    this.newProducts = this.newProducts.map(applyGift);
    this.unmatchedProducts = this.unmatchedProducts.map(applyGift);

    this.selectedRowKeys.clear();
  }

  removeAllSelectedProducts(): void {
    if (this.selectedRowKeys.size === 0) return;

    const removedOrderLineIds: number[] = [];
    const removedUnmatchedOrderLineIds: number[] = [];

    // Collect ids from persisted lines only (products + unmatchedProducts).
    this.products.forEach((p) => {
      if (!this.selectedRowKeys.has(this.getRowKey(p))) return;
      if (p.order_line_id !== null && p.order_line_id !== undefined) removedOrderLineIds.push(p.order_line_id);
    });
    this.unmatchedProducts.forEach((p) => {
      if (!this.selectedRowKeys.has(this.getRowKey(p))) return;
      // For matched-in-place products use _unmatchedLineId; otherwise use p.id
      const unmatchedId = p._unmatchedLineId ?? p.id;
      if (unmatchedId !== null && unmatchedId !== undefined) removedUnmatchedOrderLineIds.push(unmatchedId);
    });

    const shouldKeep = (p: IParseProduct) => !this.selectedRowKeys.has(this.getRowKey(p));
    this.products = this.products.filter(shouldKeep);
    this.newProducts = this.newProducts.filter(shouldKeep);
    this.unmatchedProducts = this.unmatchedProducts.filter(shouldKeep);

    // Remove deleted matched-unmatched entries from matchUnmatched.
    this.matchUnmatched = this.matchUnmatched.filter(
      (m) => !removedUnmatchedOrderLineIds.includes(m.unmatched_line_id)
    );

    // Keep removedProducts unique.
    const existing = new Set(this.removedProducts || []);
    removedOrderLineIds.forEach((id) => existing.add(id));
    this.removedProducts = Array.from(existing.values());

    const existingUnmatched = new Set(this.removedUnmatchedOrderLineIds || []);
    removedUnmatchedOrderLineIds.forEach((id) => existingUnmatched.add(id));
    this.removedUnmatchedOrderLineIds = Array.from(existingUnmatched.values());

    // Cleanup selection + rollback snapshots for removed rows.
    Array.from(this.selectedRowKeys).forEach((key) => this.rollbackSnapshots.delete(key));
    this.selectedRowKeys.clear();
  }


  onPriceInput(event: Event, product: IParseProduct): void {
    // Defense in depth (WB-7024): the input is already disabled for a
    // no-price order, but guard the entry point too.
    if (this.quotation?.all_lines_no_price) return;
    product = this.liveRow(product);
    const input = event.target as HTMLInputElement;
    const raw = Number(input.value);
    if (isNaN(raw) || raw < 0) return;
    // Rounded, not padded: padding would rewrite the field mid-keystroke.
    const val = roundPrice(raw) ?? 0;

    product.final_price = val;
    product.total = val * product.quantity;

    // Auto-detect price_type. The cascade lives in the store so this panel
    // and the order table label the same keystroke identically.
    product.price_type = this.priceCandidates.priceTypeFor(
      product,
      orderLineProductId(product),
      val
    );
    this.syncMatchUnmatchedIfNeeded(product);
  }

  /** The line whose full candidate list is open as an in-panel overlay. */
  candidatesOverlayProduct: IParseProduct | null = null;

  /**
   * The prices this customer is known to have, for the lines on screen, in one
   * call.
   *
   * The `extracted` candidate is not fetched: it is already on the line, read
   * from the document shown on the left, and asking a service for it would be a
   * second reading of one fact.
   */
  loadPriceCandidates(): void {
    this.priceCandidates.loadForLines(
      this.quotation?.location?.id_company,
      (this.products ?? []).map((product) => orderLineProductId(product)),
      this.quotation?.location?.id ?? null,
      this.quotation?.id ?? null
    );
  }

  candidatesFor(product: IParseProduct): IPriceCandidate[] {
    return this.priceCandidates.candidates(orderLineProductId(product));
  }

  policyTraceFor(product: IParseProduct): IPricePolicyTrace | null {
    return this.priceCandidates.policyTrace(orderLineProductId(product));
  }

  /** What the engine would apply — never re-derived, always the store's answer. */
  selectedCandidateFor(product: IParseProduct): IPriceCandidate | null {
    return this.priceCandidates.selected(orderLineProductId(product));
  }

  /**
   * Open the full list without leaving the panel.
   *
   * An overlay and not a drawer: the document being corrected is on the left,
   * and the value of this screen is not losing sight of it while deciding. Same
   * pattern as `productMatchEditMode`.
   */
  openCandidatesOverlay(product: IParseProduct): void {
    this.candidatesOverlayProduct = this.liveRow(product);
  }

  closeCandidatesOverlay(): void {
    this.candidatesOverlayProduct = null;
  }

  /** Seed for a price input, at price precision. */
  priceInputValue(value: number | null | undefined): number {
    return roundPrice(value) ?? 0;
  }

  onApplyPriceFromTooltip(product: IParseProduct, event: { price: number; type: PriceSourceType }): void {
    // Defense in depth (WB-7024): the tooltip already hides its Apply
    // buttons for a no-price order (viewMode), but guard the entry point too.
    if (this.quotation?.all_lines_no_price) return;
    product = this.liveRow(product);
    product.final_price = event.price;
    product.price_type = event.type;
    product.total = event.price * product.quantity;
    this.syncMatchUnmatchedIfNeeded(product);
  }

  getTotalAmount(): string {
    const total = this.products.reduce((acc, p) => acc + p.total, 0);
    return (roundPrice(total) ?? 0).toFixed(2) + ' ' + this.quotation?.currency?.symbol!;
  }

  save(): void {
    const hasLineChanges = this.hasLineChanges();

    if (hasLineChanges) {
      const update = (this.products || [])
        .map((p) => this.toUpdateLine(p))
        .filter((p): p is NonNullable<ReturnType<SideBySideCorrectionPanelComponent['toUpdateLine']>> => !!p)
        .filter((line) => this.initialUpdateLineSignatures.get(line.id) !== JSON.stringify(line));

      const add = (this.newProducts || [])
        .map((p) => this.toAddLine(p))
        .filter((p): p is NonNullable<ReturnType<SideBySideCorrectionPanelComponent['toAddLine']>> => !!p);

      const remove = Array.from(new Set(this.removedProducts || []));
      const removeUnmatched = Array.from(new Set(this.removedUnmatchedOrderLineIds || []));
      const matchUnmatched = [...this.matchUnmatched];
      const ignoreUnmatched = [...this.ignoreUnmatched];
      this.store.dispatch(UpdateQuotationLines({ id: this.quotation?.id!, payload: { update, add, remove, removeUnmatched, matchUnmatched, ignoreUnmatched } }));
    }

    if (this.hasDetailsChanges()) {
      const detailsPayload = this.buildDetailsPayload();
      if (Object.keys(detailsPayload).length > 0) {
        // WB-7569 — remember whether this save could have moved the company, so
        // the success handler knows if a missing `segregation_check` is worth
        // re-checking. Any other save simply leaves the current tag alone.
        this.pendingCompanyChangeCheck = 'id_company' in detailsPayload;
        this.store.dispatch(UpdateQuotationDetails({ id: this.quotation?.id!, payload: detailsPayload }));
      }
    }

    if (!hasLineChanges && !this.hasDetailsChanges()) {
      this.closeAfterSave();
    }
  }

  /**
   * Clears every staged line mutation after a successful save, and re-baselines the
   * line signatures.
   *
   * NB: `applyQuotationData` (which does rebuild the baseline for every line) only
   * runs on the FIRST load — later store updates go through `mergeQuotationData`. So
   * the baseline has to be reset here; it cannot be left to the refetch.
   */
  private resetPendingLineChanges(): void {
    this.newProducts = [];
    this.removedProducts = [];
    this.removedUnmatchedOrderLineIds = [];
    this.matchUnmatched = [];
    this.ignoreUnmatched = [];
    this.cancelAddProduct();
    // The server just accepted these values, so they ARE the baseline now. Without
    // this, `hasLineChanges()` keeps comparing saved lines against their pre-edit
    // signatures and `isDirty` never clears — which leaves "Unsaved changes" lit and
    // Approve Order disabled for the rest of the panel's life. Refetching does not
    // cover it: after first load the response goes to `mergeQuotationData`, which only
    // rebaselines lines it appends.
    this.rebaselineLineSignatures();
    // Same reason as the details rebaseline: the lines are clean now, and the
    // deferred split proposal reads `isDirty` in this same synchronous handler.
    this.invalidateDirtyCache();
  }

  /** Snapshots the current lines as the "no pending changes" reference. */
  private rebaselineLineSignatures(): void {
    this.initialUpdateLineSignatures.clear();
    (this.products || []).forEach((product) => {
      const line = this.toUpdateLine(product);
      if (line) {
        this.initialUpdateLineSignatures.set(line.id, JSON.stringify(line));
      }
    });
  }

  /**
   * WB-7478: from the order-details page a save closes the panel (unchanged
   * behaviour). From Smart Inbox the user stays in the panel so they can go on
   * to approve — only Approve Order closes it. The order is refetched so the
   * panel reflects what actually persisted.
   */
  private closeAfterSave(): void {
    if (!this.isSmartInboxOrigin) {
      this.animateClose();
      return;
    }
    if (this.quotation?.id) {
      this.store.dispatch(GetQuotationById({ id: this.quotation.id }));
    }
  }

  // ── Segregation / splitting rules (WB-7569) ────────────────────────────────

  /**
   * Splitting is blocked while there are unsaved edits, for the same reason
   * Approve is (`isApproveBlocked`): `split-in-place` regroups the lines the
   * SERVER holds and never sees the staged work, so confirming would drop it
   * silently. The tag stays visible but inert, with the same "save first" copy.
   */
  get isSplitPreviewBlocked(): boolean {
    return this.isDirty;
  }

  /** WB-7938 — the duplicate badge reached this header along with the rest of the strip. */
  dismissDuplicateBadge(): void {
    const orderId = this.quotation?.id;
    if (orderId == null) return;
    this.store.dispatch(DismissDuplicateBadge({ id: orderId }));
  }

  /**
   * Opens the split proposal for the current order.
   *
   * Entered either automatically after a save that made a rule applicable, or
   * manually from the "Split applies" tag — the tag is what makes dismissing the
   * modal recoverable.
   *
   * `onResolved` runs once the modal (and any resulting split) is done with, so
   * the save flow can defer its close until then.
   *
   * Refuses to open on a dirty panel: confirming would discard the staged line
   * work (see `isSplitPreviewBlocked`). The tag is disabled in that state, and
   * the auto-open path defers to `UpdateQuotationLinesSuccess` rather than
   * arriving here dirty — this is the backstop for both.
   *
   * Returns whether the modal actually opened, so callers that handed it their
   * post-save close know whether `onResolved` will ever run.
   */
  openSplitPreview(onResolved?: () => void): boolean {
    const check = this.segregationCheck;
    const orderId = this.quotation?.id;
    if (!check || orderId == null || this.segregationModalOpen) return false;
    if (this.isSplitPreviewBlocked) return false;

    this.segregationModalOpen = true;
    this.segregationPreview.openPreview(
      orderId,
      this.quotation?.name ?? `#${orderId}`,
      { mechanism: check.mechanism, groups: check.groups },
    ).pipe(
      takeUntil(this.destroy$)
    ).subscribe((outcome) => {
      this.segregationModalOpen = false;
      if (outcome === 'split') this.reloadAfterSplit(orderId);
      onResolved?.();
    });
    return true;
  }

  /**
   * Auto-presents the split proposal after a save, so the possibility is never
   * something the user has to remember. Every save that touches customer info
   * runs through here — first assignment or a later company change alike.
   *
   * Returns true when it took ownership of the post-save close, either by
   * opening the modal now or by parking it until the line changes from the same
   * save land (opening on top of those would discard them — see
   * `reloadAfterSplit`). False means nothing applies and the caller should close
   * as usual.
   */
  private autoOpenSegregationIfApplicable(): boolean {
    if (!this.segregationCheck) return false;

    // Deferred to the modal's resolution rather than run now: from the
    // order-details entry point `closeAfterSave` animates the panel away, which
    // would tear down the host of the modal we just opened.
    const onResolved = () => {
      if (!this.hasLineChanges()) this.closeAfterSave();
    };

    if (this.hasLineChanges()) {
      this.deferredSegregationOpen = onResolved;
      return true;
    }
    return this.openSplitPreview(onResolved);
  }

  /**
   * Re-syncs the open panel with what the split left behind.
   *
   * `split-in-place` keeps this order's id and strips it down to a single
   * group's lines, so the panel must not keep rendering the lines that moved to
   * the sibling orders. The refetch goes through `mergeQuotationData`, which
   * drops any row whose `order_line_id` the server no longer returns and
   * rebaselines the rest, so the dirty state stays honest.
   *
   * Deliberately does NOT call `resetPendingLineChanges()`. That is the
   * post-save helper: it assumes the server just accepted the staged values and
   * rebaselines them as such. `split-in-place` never sees them, so calling it
   * here dropped `newProducts` / `removedProducts` / `matchUnmatched` /
   * `ignoreUnmatched` / `removedUnmatchedOrderLineIds` and silently rebaselined
   * per-line edits — the row kept showing the edited value while `isDirty` read
   * false. Splitting is gated on a clean panel instead, so there is nothing
   * staged to reconcile by the time we get here.
   *
   * The alternatives cache still has to go: it is keyed by line id and those
   * lines have moved.
   *
   * The sibling orders created by the split surface on the conversation
   * timeline — that is WB-7566's job, not this panel's.
   */
  private reloadAfterSplit(orderId: number): void {
    this.segregationCheck = null;
    this.didSplitOrder = true;
    this.quotesService.clearAlternativesBulkCache(orderId);
    this.priceCandidates.invalidate();
    this.store.dispatch(GetQuotationById({ id: orderId }));
  }

  /**
   * Asks the backend whether a splitting rule already applies to this order, so
   * the tag is present on open and not only after a save in this session.
   *
   * Fire-and-forget: `checkApplicable` swallows errors into `null`, because the
   * tag is an affordance and must never block or noise up the panel.
   */
  private refreshSegregationApplicability(
    options?: { force?: boolean; onSettled?: () => void },
  ): void {
    const orderId = this.quotation?.id;
    const partnerId = this.quotation?.location?.id;
    // `onSettled` must run on EVERY path including this bail-out: the post-save
    // close is waiting on it, and an order with no partner would otherwise leave
    // the panel hanging open.
    if (orderId == null || partnerId == null || !this.approvableFromStatus) {
      options?.onSettled?.();
      return;
    }

    this.segregationPreview.checkApplicable(
      orderId,
      partnerId,
      this.quotation?.order_company?.id,
    ).pipe(
      takeUntil(this.destroy$)
    ).subscribe((check) => {
      // On the first-load path a save landing while the request was in flight
      // already wrote the authoritative answer — do not overwrite it with this
      // staler one. `force` is the company-changed path, where re-evaluating the
      // proposal is the whole point of asking.
      if (options?.force || !this.segregationCheck) this.segregationCheck = check;
      options?.onSettled?.();
    });
  }

  // ── Quick-actions row (WB-7478) ────────────────────────────────────────────

  /**
   * Whether the strip renders. Off by default (see
   * `QuickActionsPreferencesService.isEnabled`).
   *
   * Available from both entry points, and intentionally sharing one preference
   * bucket: it is the same panel, so a user who turns the row on (or reorders its
   * fields) expects that to hold wherever they open it from.
   */
  get showQuickActionsRow(): boolean {
    return this.quickActionsEnabled && !this.dataLoading && !this.loadError;
  }

  toggleQuickActionsRow(): void {
    this.quickActionsEnabled = !this.quickActionsEnabled;
    this.quickActionsPrefs.setEnabled(
      SideBySideCorrectionPanelComponent.QUICK_ACTIONS_KEY,
      this.quickActionsEnabled
    );
  }

  onQuickActionsFieldsChange(fields: IQuickActionField[]): void {
    this.quickActionFields = fields;
    this.quickActionsPrefs.save(SideBySideCorrectionPanelComponent.QUICK_ACTIONS_KEY, fields);
  }

  onQuickAction(event: QuickActionEvent): void {
    switch (event.type) {
      // Company/location live in the panel's save-on-confirm details draft, so the
      // chip reveals the Details tab. The embedded selector is only forced open
      // when the value is actually missing — that is the case the row exists to
      // fix. With a resolved value, dropping the user straight into a picker they
      // did not ask for would be presumptuous; they can still click the field.
      case 'edit-company':
        this.revealDetailsTab();
        if (event.missing) this.openCompanyLocationEditor('company');
        return;
      case 'edit-location':
        this.revealDetailsTab();
        if (event.missing) this.openCompanyLocationEditor('location');
        return;
      // PO number / Quote ID are plain text fields on the details draft. Reveal the
      // tab, then focus the input so the user can type straight away — the row's
      // job is to remove the hunt for the field, not to duplicate the editor.
      case 'focus-field':
        this.revealDetailsTab();
        this.focusDetailsField(event.field);
        return;
      case 'copy':
        this.copyToClipboard(event.value);
        return;
    }
  }

  /**
   * Switches to the Details tab AND dismisses the company/location selector.
   *
   * Both are required: the overlay and the tab body are mutually exclusive in the
   * template, so leaving the selector up means the tab never renders — the click
   * looks inert, and any input we then try to focus does not exist yet. Safe to
   * call before `openCompanyLocationEditor()`, which sets the flag back itself.
   */
  private revealDetailsTab(): void {
    this.leftPanelActiveTab = 'details';
    this.companyLocationEditMode = false;
  }

  /**
   * Focuses a details-tab input after the tab has rendered. The tab content is
   * behind an `*ngIf`, so the element does not exist until the next tick.
   */
  private focusDetailsField(field: 'po_number' | 'quote_id'): void {
    setTimeout(() => {
      // These rows are inline editors now: opening one focuses its input, so
      // ask the block to start editing rather than reaching for an element that
      // only exists while editing (WB-7463).
      const key = field === 'po_number' ? 'customer_po_number' : 'quote_id';
      this.orderReferencesList?.startEdit(key);
    });
  }

  /** Inline shipping-date edit from the row, committed through the details draft. */
  onQuickActionsShippingDateChange(date: Date | null): void {
    this.detailsDraft.shippingDate = SideBySideCorrectionPanelComponent.toLocalIsoDate(date);
  }

  /** Reassignment already persisted in the popover — mirror it locally. */
  onQuickActionsOwnerChanged(owner: IOrderUser): void {
    if (!this.quotation) return;
    this.quotation = { ...this.quotation, owner };
    this.detailsDraft.ownerId = owner.id;
    this.detailsDraft.ownerName = owner.name;
    // Rebase ONLY the owner key. Recomputing the whole signature here would fold
    // every other pending edit into the baseline, so a PO number / quote id / date /
    // company change typed before the reassignment would stop counting as unsaved
    // and be dropped by the next save(). `ownerName` is not part of the signature.
    const baseline = JSON.parse(this.initialDetailsSignature || '{}');
    this.initialDetailsSignature = JSON.stringify({ ...baseline, ownerId: owner.id });
    this.refreshQuickActionFields();
  }

  private copyToClipboard(value: string): void {
    if (!value) return;
    navigator.clipboard?.writeText(value).then(
      () => this.commonService.showToast(
        this.translateService.instant('quick_actions.copied'),
        'SUCCESS'
      ),
      () => undefined
    );
  }

  private initQuickActions(): void {
    const key = SideBySideCorrectionPanelComponent.QUICK_ACTIONS_KEY;
    this.quickActionsEnabled = this.quickActionsPrefs.isEnabled(key);
    this.refreshQuickActionFields();
  }

  private refreshQuickActionFields(): void {
    this.quickActionFields = this.quickActionsPrefs.applyPreferences(
      SideBySideCorrectionPanelComponent.QUICK_ACTIONS_KEY,
      SideBySideCorrectionPanelComponent.DEFAULT_QUICK_ACTION_FIELDS.map((field) => ({ ...field }))
    );
  }

  // ── Smart Inbox header actions (WB-7478) ───────────────────────────────────

  /**
   * Approve the order through the shared status-transition modal.
   *
   * The panel deliberately does NOT close on dispatch. It has to outlive the request
   * to mirror the order-details approval flow: the ERP can reject lines, and those
   * follow-ups (missing products / insufficient inventory) are part of approving.
   * Closing early swallowed them and reported success regardless — see
   * `onApproveResolved`.
   */
  approveOrder(): void {
    const fromStatus = this.approvableFromStatus;
    if (!fromStatus) return;
    this.orderStatusDialog.openApproveOrder({
      fromStatus,
      onConfirm: () => {
        this.approveInFlight = true;
        this.store.dispatch(validateOrder({ id: this.quotation?.id! }));
      },
    });
  }

  /**
   * Mirrors `DetailsQuotesComponent`'s `validateOrderSuccess` handling.
   *
   * A force-send retry resolves a second time; the flag stops it re-entering. When
   * the ERP reports a conflict the panel stays open on the follow-up dialog so the
   * user can remove products or force approval — exactly as the details page does.
   * Only a clean approve closes, and only after refetching, so the store no longer
   * holds a stale pre-approval snapshot for the next open.
   */
  private onApproveResolved(response: ISentToErpRespone): void {
    if (!this.approveInFlight) return;

    const missingProducts = response.erp_missing_products;
    const missingInventory = response.erp_missing_inventory;

    if (Array.isArray(missingProducts) && missingProducts.length > 0) {
      const allProductsMissing = this.products.length === missingProducts.length;
      this.orderStatusDialog.openErpMissingProducts({
        missingProducts,
        allProductsMissing,
        onRemoveProducts: () => this.store.dispatch(
          validateOrder({ id: this.quotation?.id!, shouldDelete: true })
        ),
      });
      this.refreshAfterApprove();
      return;
    }

    if (Array.isArray(missingInventory) && missingInventory.length > 0) {
      this.orderStatusDialog.openErpMissingInventory({
        missingInventory,
        onForceApprove: () => this.store.dispatch(
          validateOrder({ id: this.quotation?.id!, force: true })
        ),
      });
      this.refreshAfterApprove();
      return;
    }

    // Clean approve: the order is in the ERP. Refetch so the status badge and
    // read-only state are right if anything reopens this order, then close with a
    // result so Smart Inbox can refresh its timeline.
    this.approveInFlight = false;
    this.refreshAfterApprove();
    this.animateClose(SIDE_BY_SIDE_RESULT_APPROVED);
  }

  /**
   * Closes with the mutation's result, but only for the mutation this panel started —
   * these actions are global, so another surface's cancel/archive/delete must not
   * close this panel.
   */
  private closeAfterMutation(result: SideBySidePanelResult): void {
    if (this.mutationInFlight !== result) return;
    this.mutationInFlight = null;
    this.animateClose(result);
  }

  /**
   * `validateOrderSuccess` carries only the two `erp_missing_*` flags — no id and no
   * status — and no reducer handles it, so the store keeps the pre-approval order
   * until something refetches. The details page does the same thing.
   */
  private refreshAfterApprove(): void {
    if (!this.quotation?.id) return;
    this.store.dispatch(GetQuotationById({
      id: this.quotation.id,
      skipGlobalLoader: true,
      paginate_lines: true,
      page: 1,
      limit: DEFAULT_LINES_PAGE_SIZE,
      include_ai_details: false,
    }));
  }

  /** Opens the full order-details page in a new tab. */
  viewFullDetails(): void {
    if (!this.quotation?.id) return;
    window.open(`${window.location.origin}/quotations/${this.quotation.id}`, '_blank');
  }

  /**
   * The destructive and lifecycle actions all go through the existing store
   * actions rather than calling `QuotesService` directly, so their effects keep
   * the orders list and the detail cache in sync exactly as the list row menu
   * does today.
   */
  duplicateOrder(): void {
    if (!this.quotation?.id) return;
    const id = this.quotation.id;
    this.orderStatusDialog.openDuplicateOrder({
      name: this.quotation.name,
      onConfirm: () => {
        // The effect routes to the new order's details page, so leaving the panel
        // open would strand it over a different record showing the original.
        this.store.dispatch(DuplicateQuotation({ id }));
        this.animateClose();
      },
    });
  }

  downloadPdf(): void {
    if (!this.quotation?.id) return;
    const filename = `${this.quotation.name ?? 'order'}.pdf`;
    this.quotesService.getPdfQuotation(this.quotation.id).pipe(take(1)).subscribe({
      next: (blob) => this.saveBlob(blob, filename),
      error: () => this.commonService.showToast(
        this.translateService.instant('quotations_and_orders.side_by_side_panel.actions.download_failed'),
        'ERROR'
      ),
    });
  }

  /**
   * CSV of the order's product lines, built client-side by the same service the
   * Documents tab and the Activity products preview use — identical output.
   */
  downloadCsv(): void {
    const products = this.products ?? [];
    if (!products.length) return;
    this.exportService.downloadProductsCsv(products, `${this.quotation?.name ?? 'order'}.csv`);
  }

  cancelOrder(): void {
    if (!this.quotation?.id) return;
    const id = this.quotation.id;
    this.orderStatusDialog.openCancelOrder({
      onConfirm: () => {
        // Closes from the success handler, not here — see `mutationInFlight`.
        this.mutationInFlight = SIDE_BY_SIDE_RESULT_CANCELLED;
        this.store.dispatch(cancelQuotation({ id }));
      },
    });
  }

  archiveOrder(): void {
    if (!this.quotation?.id) return;
    const id = this.quotation.id;
    this.orderStatusDialog.openArchiveOrder({
      name: this.quotation.name,
      onConfirm: () => {
        // Closes from the success handler, not here — see `mutationInFlight`.
        this.mutationInFlight = SIDE_BY_SIDE_RESULT_ARCHIVED;
        this.store.dispatch(ArchiveQuotation({ id, quotationName: this.quotation?.name }));
      },
    });
  }

  deleteOrder(): void {
    if (!this.quotation?.id) return;
    const id = this.quotation.id;
    this.orderStatusDialog.openDeleteOrder({
      onConfirm: () => {
        // Closes from the success handler, not here — see `mutationInFlight`.
        this.mutationInFlight = SIDE_BY_SIDE_RESULT_DELETED;
        this.store.dispatch(deleteQuotation({ id, confirm: true }));
      },
    });
  }

  /**
   * Archiving/deleting an order that already reached the ERP is blocked, mirroring
   * `DELETE_BLOCKED_STATUSES` in the orders list.
   */
  get canArchiveOrder(): boolean {
    return !this.quotation?.is_archived && !this.isReadOnlyRecord;
  }

  get canDeleteOrder(): boolean {
    return !this.isReadOnlyRecord && !this.quotation?.external_id;
  }

  private saveBlob(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  isCompanyMissing(): boolean {
    const name = this.detailsDraft?.partnerCompanyName?.trim();
    return !name || name === 'N/A';
  }

  /** Billing company shown in the company row, read from the order's `order_company`. */
  isOrderCompanyMissing(): boolean {
    const name = this.quotation?.order_company?.name?.trim();
    return !name || name === 'N/A';
  }

  /**
   * True when the shipping location belongs to a company different from the
   * billing one — the case the location row shows as a company tag next to the
   * location tag.
   *
   * Computed from the DRAFTED location (WB-8331) so a cross-company pick is
   * flagged straight away. The ids are compared directly rather than trusting
   * `is_different_company`: that flag is produced by the quotation parser only,
   * so a location coming back from the selector never carries it. The flag is
   * still honoured as a fallback for the payloads that omit `id_company`.
   */
  isLocationDifferentCompany(): boolean {
    const location = this.detailsDraft?.shippingLocation;
    const locationCompanyId = location?.id_company;
    const billingCompanyId = this.detailsDraft?.partnerCompanyId;
    if (locationCompanyId != null && billingCompanyId != null) {
      return locationCompanyId !== billingCompanyId;
    }
    return !!location?.is_different_company;
  }

  /**
   * The shipping location's own company name, for the tag shown beside the
   * location when the two companies differ. Only the payloads that can actually
   * carry a cross-company location populate it — a location picked out of the
   * selected company's own list is by definition not a different company.
   */
  shippingLocationCompanyName(): string | undefined {
    return this.detailsDraft?.shippingLocation?.company_name || undefined;
  }

  isLocationMissing(): boolean {
    const name = this.detailsDraft?.partnerName?.trim();
    return !name || name === 'N/A';
  }

  /** Company name Volta parsed from the source document, shown while the order has no company. */
  extractedCompanyRaw(): string | undefined {
    return this.quotation?.ai_details?.extracted_info?.customer?.company;
  }

  extractedShippingRaw(): string | undefined {
    return this.quotation?.ai_details?.extracted_info?.shipping?.raw_address;
  }

  shippingAutofillSource(): string | null | undefined {
    return this.quotation?.ai_details?.shipping_autofill_source;
  }

  shippingHintTooltip(): string {
    const src = this.shippingAutofillSource();
    if (src === 'multiple_locations') {
      return this.translateService.instant('quotations_and_orders.side_by_side_panel.details.shipping_autofill.multiple_locations');
    }
    if (src === 'no_locations') {
      return this.translateService.instant('quotations_and_orders.side_by_side_panel.details.shipping_autofill.no_locations');
    }
    return '';
  }

  /**
   * true when the AI extracted a shipping address it could not confidently
   * match and the buyer company has a single location the BO can confirm with one tap.
   */
  isSingleLocationSoftMatch(): boolean {
    return this.shippingAutofillSource() === 'single_location_soft_match'
      && this.isLocationMissing()
      && !this.quotation?.ai_details?.suggested_shipping_location_dismiss;
  }

  suggestedShippingLocation() {
    return this.quotation?.ai_details?.suggested_shipping_location;
  }

  /**
   * Discard the AI suggested shipping location: persist the dismissal
   * (POST .../ai_details/location/dismiss). On success the store flips the
   * suggested_shipping_location_dismiss flag on ai_details, which this panel
   * mirrors via `mergeQuotationData`, so the suggestion UI hides automatically.
   */
  discardSuggestedLocation(): void {
    const id = this.quotation?.id;
    if (!id) return;
    this.store.dispatch(DismissSuggestedLocation({ id }));
  }

  /**
   * Confirm the single suggested shipping location. Unlike the order-details page
   * (immediate PATCH), the side-by-side panel is deferred: apply the suggestion to
   * `detailsDraft` — exactly as `onSelectorCompleted()` does — so it persists on Save.
   * The "Use this location" button click is itself the confirmation.
   */
  confirmSuggestedLocation(): void {
    const suggested = this.suggestedShippingLocation();
    if (!suggested?.id) return;
    this.detailsDraft = {
      ...this.detailsDraft,
      partnerId: suggested.id,
      partnerName: suggested.name,
      shippingAddress: suggested.shipping_address,
      // The suggestion is a lightweight {id, name, shipping_address} object, so
      // the derived rows go blank until the save round-trips the full location.
      // Blank is the honest state here — keeping the previous location's ERP id
      // and tax codes next to a different location's name is what WB-8331 is.
      shippingLocation: suggested as ILocation,
    };
    this.buildDetailFields();
  }

  /**
   * Seeds and opens the inline company/location selector at the given step
   * (`company` for the company row, `location` for the shipping row, `create` for add-location).
   */
  openCompanyLocationEditor(
    initialStep?: 'company' | 'location' | 'create',
    prefill?: { apartment?: string },
  ): void {
    if (this.viewMode) return;
    this.selectorCompany = this.isCompanyMissing()
      ? null
      : { id: this.detailsDraft.partnerCompanyId, name: this.detailsDraft.partnerCompanyName } as unknown as ICustomer;
    this.selectorLocation = this.isLocationMissing()
      ? null
      : { id: this.detailsDraft.partnerId, name: this.detailsDraft.partnerName } as ILocation;
    this.selectorInitialStep = initialStep;
    this.selectorPrefill = prefill;
    this.companyLocationEditMode = true;
  }

  /** Add a new shipping location from the AI-extracted raw address (opens at the create step). */
  addNewLocation(): void {
    const rawAddress = this.extractedShippingRaw();
    if (!rawAddress) return;

    const company = this.quotation?.order_company
      ? { id: this.quotation.order_company.id, name: this.quotation.order_company.name } as unknown as ICustomer
      : null;

    this.selectorCompany = company;
    this.selectorLocation = null;
    this.selectorInitialStep = 'create';
    // Location name is entered manually (required); only the address is prefilled.
    this.selectorPrefill = {
      apartment: rawAddress,
    };
    this.companyLocationEditMode = true;
  }

  onSelectorCompleted(result: CompanyLocationResult): void {
    const orderDetail = (result as { orderDetail?: IQuotationDetail }).orderDetail;
    if (orderDetail) {
      // A location was created inline AND attached to the order; the order is already updated
      // server-side, so merge it into the store.
      // WB-7569 — this response comes from `addNewLocation`, which never carries
      // `segregation_check`, yet it does attach a company. Flag it so the success
      // handler re-checks applicability instead of leaving a now-stale tag (or no
      // tag where a rule has just become applicable).
      this.pendingCompanyChangeCheck = true;
      this.store.dispatch(UpdateQuotationDetailsSuccess({ changes: orderDetail, orderId: orderDetail.id }));
      this.companyLocationEditMode = false;
      return;
    }

    const selected = result as { company?: ICustomer | null; location?: ILocation | null };
    const previousCompanyId = this.detailsDraft.partnerCompanyId;
    this.detailsDraft = {
      ...this.detailsDraft,
      partnerId: selected.location?.id,
      partnerName: selected.location?.name,
      partnerCompanyId: selected.company?.id as unknown as number,
      partnerCompanyName: selected.company?.name,
      shippingAddress: SideBySideCorrectionPanelComponent.shippingAddressOf(selected.location),
      shippingLocation: selected.location ?? null,
    };
    this.companyLocationEditMode = false;
    // WB-8331: the Shipping block's derived rows (ERP id, tax codes, contacts)
    // are produced by `buildDetailFields`, not bound to the draft in the
    // template. Without this call they kept showing the location the user had
    // just replaced, so only the name tag appeared to change.
    this.buildDetailFields();

    // Any company change invalidates emails staged against the prior company,
    // so the staging never outlives the selection it was made for (e.g. reverting
    // to the original company drops them — guarding against a wrongful write if an
    // unrelated detail is then saved).
    const matchedCompanyId = selected.company?.id as unknown as number | undefined;
    if (matchedCompanyId !== previousCompanyId) {
      this.pendingCompanyEmails = null;
    }

    // Offer enrichment only for a genuinely new company — different from both the
    // order's original company (so re-selecting it never prompts, matching the
    // order details page) and the currently-shown one (so re-confirming the same
    // pick doesn't reopen the dialog).
    const originalCompanyId = this.quotation?.order_company?.id ?? this.quotation?.location?.id_company;
    if (matchedCompanyId
      && matchedCompanyId !== originalCompanyId
      && matchedCompanyId !== previousCompanyId) {
      // The selector's company object already carries its locations (loaded via
      // getCompanyById), so offer them as the Shipping Location scope directly.
      this.maybeOpenEnrichEmailsDialog(
        matchedCompanyId, selected.company?.name, selected.company?.locations ?? [],
      );
    }
  }

  onSelectorCancelled(): void {
    this.companyLocationEditMode = false;
  }

  /**
   * After a manual company match in the details tab, offer to add the AI-parsed
   * sender email(s) to that company's Email Registry so future orders auto-match.
   * No-op when no sender address was parsed. The registry is loaded first so
   * already-registered emails open pre-toggled.
   *
   * Opened in deferred mode: the dialog returns the chosen addresses instead of
   * writing them, and we stage them (commitPendingCompanyEmails writes them only
   * once the panel's Save succeeds).
   */
  private maybeOpenEnrichEmailsDialog(companyId: number, companyName?: string, locations: ILocation[] = []): void {
    const extractedEmails = this.getParsedEmails(this.quotationSourceContent);
    if (extractedEmails.length === 0) return;
    this.loadCompanyRegistry(companyId, () => {
      this.dialog.open(EnrichCompanyEmailsDialogComponent, {
        data: {
          customerId: companyId,
          companyName,
          emails: extractedEmails,
          registeredEmails: this.companyRegistryEmails,
          locations,
          deferSave: true,
        },
      }).afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: IEnrichCompanyEmailsDeferredResult | false | undefined) => {
        // Deferred mode resolves with { emails, locationId }; cancel resolves with
        // false/undefined. Stage them against this company (and optional location).
        if (result && Array.isArray(result.emails) && result.emails.length > 0) {
          this.pendingCompanyEmails = { companyId, locationId: result.locationId, emails: result.emails };
        }
      });
    });
  }

  /**
   * Write the staged enrich-dialog emails to the matched company's registry via
   * the bulk endpoint. Called from the UpdateQuotationDetailsSuccess handler so
   * the write lands only after a successful save. Deliberately NOT tied to
   * destroy$ — the panel closes on save-success, and the request must outlive
   * that close; the HTTP observable completes and unsubscribes itself.
   */
  private commitPendingCompanyEmails(): void {
    const pending = this.pendingCompanyEmails;
    this.pendingCompanyEmails = null;
    if (!pending || pending.emails.length === 0) return;

    const request$ = pending.locationId != null
      ? this.customerEmailService.createLocationBulk({ location_id: pending.locationId, emails: pending.emails })
      : this.customerEmailService.createBulk({ customer_id: pending.companyId, emails: pending.emails });

    request$
      .subscribe({
        next: () => this.commonService.showToast(
          this.translateService.instant('quotations_and_orders.enrich_company_emails.success'),
          'SUCCESS',
        ),
        error: () => this.commonService.showToast(
          this.translateService.instant('quotations_and_orders.enrich_company_emails.error'),
          'ERROR',
        ),
      });
  }

  /** Extract the first email address from a raw header value (e.g. "Name <a@b.com>"). */
  private extractEmailAddress(raw: string | undefined | null): string | null {
    if (!raw) return null;
    const match = raw.match(/[^\s<>@]+@[^\s<>@]+\.[^\s<>@]+/);
    return match ? match[0].trim() : null;
  }

  /** Parsed sender address from the AI analysis. Normalized in case original_sender
   * ever arrives as a "Name <a@b.com>" header value. */
  private getSenderEmail(content: IQuotationSourceContent | undefined | null): string | null {
    return this.extractEmailAddress(content?.ai_details?.extracted_info?.original_sender) ?? '';
  }

  /** The original sender plus every address in customer.emails, de-duplicated
   * case-insensitively. customer.emails is optional in the payload (legacy orders
   * carry only the singular email), so it is guarded. */
  private getParsedEmails(content: IQuotationSourceContent | undefined | null): string[] {
    const sender = this.getSenderEmail(content);
    const extracted = content?.ai_details?.extracted_info?.customer?.emails?.map((e) => e.email) ?? [];
    const candidates = [sender, ...extracted].map((e) => e?.trim()).filter((e): e is string => !!e);
    return candidates.filter(
      (email, i) => candidates.findIndex((e) => e.toLowerCase() === email.toLowerCase()) === i,
    );
  }

  /** Load the matched company's email registry once per company so the enrich
   * dialog opens with already-registered emails pre-toggled. `onLoaded` runs once
   * the registry for `companyId` is available (immediately if already loaded, or
   * after the in-flight/started fetch resolves). */
  private loadCompanyRegistry(companyId: number | null | undefined, onLoaded?: () => void): void {
    if (!companyId) return;
    // Already loaded for this company → run the callback now.
    if (this.registryLoadedForCompanyId === companyId && this.companyRegistryLoaded) {
      onLoaded?.();
      return;
    }
    if (onLoaded) this.registryLoadCallbacks.push(onLoaded);
    // A fetch for this company is already in flight → just wait for it.
    if (this.registryLoadedForCompanyId === companyId) return;

    this.registryLoadedForCompanyId = companyId;
    this.companyRegistryLoaded = false;
    this.customerEmailService.list(companyId).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if (this.registryLoadedForCompanyId !== companyId) return; // superseded by a newer company
        this.companyRegistryEmails = new Set(
          (response?.data ?? [])
            .map((row) => (row.email ?? '').trim().toLowerCase())
            .filter(Boolean),
        );
        this.finishRegistryLoad();
      },
      // Fail open: a same-company duplicate is handled benignly on save (HTTP 409).
      error: () => {
        if (this.registryLoadedForCompanyId !== companyId) return;
        this.companyRegistryEmails = new Set<string>();
        this.finishRegistryLoad();
      },
    });
  }

  private finishRegistryLoad(): void {
    this.companyRegistryLoaded = true;
    const callbacks = this.registryLoadCallbacks;
    this.registryLoadCallbacks = [];
    callbacks.forEach((callback) => callback());
  }

  // `onPoNumberInput` / `onQuoteIdInput` / `onDetailsDeliveryDateChange` were
  // removed by WB-7463: those rows are inline editors that write to the draft
  // through `onDetailFieldValueChange`.

  /**
   * `yyyy-MM-dd` from a date's LOCAL calendar fields.
   *
   * Not `toISOString().slice(0, 10)`: that shifts to UTC first, so a user east of
   * Greenwich picking a date before their offset (e.g. 00:30 at UTC+2) would store
   * the previous day.
   */
  private static toLocalIsoDate(date: Date | null | undefined): string {
    if (!date) return '';
    const pad = (n: number) => `${n}`.padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  }

  onOwnerSearchInput(value: string): void {
    this.ownerSearch$.next(value?.trim() ?? '');
  }

  enterOwnerEdit(): void {
    this.ownerEditMode = true;
    this.ownerSearchControl.setValue('', { emitEvent: false });
    this.ownerSearch$.next('');
    setTimeout(() => this.ownerSearchInput?.nativeElement.focus());
  }

  cancelOwnerEdit(): void {
    this.ownerEditMode = false;
    this.ownerSearchControl.setValue('', { emitEvent: false });
  }

  onOwnerSearchBlur(): void {
    setTimeout(() => {
      if (this.ownerEditMode) this.cancelOwnerEdit();
    }, 200);
  }

  onOwnerSelected(event: MatAutocompleteSelectedEvent): void {
    const user = event.option.value as IOrderUser;
    this.detailsDraft.ownerId = user.id;
    this.detailsDraft.ownerName = user.name;
    this.ownerSearchControl.setValue('', { emitEvent: false });
    this.ownerEditMode = false;
  }

  clearOwner(): void {
    this.detailsDraft.ownerId = undefined;
    this.detailsDraft.ownerName = undefined;
    this.ownerSearchControl.setValue('', { emitEvent: false });
    this.ownerSearch$.next('');
    this.ownerEditMode = false;
  }

  toggleContentExpanded(): void {
    this.contentExpanded = !this.contentExpanded;
  }

  /** Template handler: select, and latch that the choice is now the USER's (WB-7399). */
  onAttachmentClick(attachmentUrl: string): void {
    this.userPickedAttachment = true;
    this.selectAttachment(attachmentUrl);
  }

  /** Programmatic selection (auto-select / re-select). Does NOT set the user latch. */
  private selectAttachment(attachmentUrl: string): void {
    this.selectedAttachmentUrl = attachmentUrl;
    // Create a new array reference to trigger change detection
    this.currentAttachment = [attachmentUrl];
    // Overlays are suppressed on non-source documents, so drop the active line — otherwise a
    // left-hand row stays emphasized with nothing on the document to justify it.
    this.activeLineKey = null;
    this.activeField = null;
  }

  /** Every line that can carry a `source` (WB-7399). */
  private orderSourceLines(): IOrderSourceLine[] {
    return [
      ...(this.products ?? []),
      ...(this.unmatchedProducts ?? []),
      ...(this.quotation?.ai_details?.matched_unmatched_order_lines ?? []),
    ];
  }

  /**
   * WB-7399: default the preview to the document the order lines were parsed from.
   *
   * WB-8267: when they name NO attachment, BOTH fallbacks apply — the body opens
   * (`applyBodyExpandDefault`) because it is the only source view certain to be right, and the
   * best-ranked file is still previewed beside it (`preferredPreviewAttachment`) rather than
   * leaving the pane blank. Ranked by format, not by position: `attachments[0]` on a
   * multi-attachment order (Equilibra) is as likely to be a signature image as the order.
   *
   * Idempotent, so it is safe on every store emission.
   */
  private autoSelectPreviewAttachment(): void {
    const attachments = this.quotationSourceContent?.email?.attachments ?? [];
    if (attachments.length && this.selectedAttachmentUrl && !attachments.includes(this.selectedAttachmentUrl)) {
      // Matched by PATH, not exact URL: presigned URLs are re-signed on every refetch, so a
      // byte-for-byte `includes` would treat the SAME file as gone and discard a manual pick.
      // Only when we actually know the new list — an empty one means "not resolved yet".
      const key = attachmentPathKey(this.selectedAttachmentUrl);
      const resigned = key ? attachments.find((a) => attachmentPathKey(a) === key) : undefined;
      if (resigned) {
        this.selectedAttachmentUrl = resigned;
        this.currentAttachment = [resigned];
      } else {
        this.selectedAttachmentUrl = '';
        this.currentAttachment = [];
        this.userPickedAttachment = false;
        this.previewMatchLatched = false;
        this.bodyDefaultApplied = false;
      }
    }
    if (this.previewMatchLatched) {
      return; // resolution already settled for this attachment list
    }
    this.resolvedSourceAttachment = this.resolveSourceAttachment(attachments);
    this.previewMatchLatched = !!this.resolvedSourceAttachment;
    this.applyBodyExpandDefault();
    if (this.userPickedAttachment) {
      return; // the resolution still updates — the overlay guard needs it — but the pick is theirs
    }
    const url = this.resolvedSourceAttachment || preferredPreviewAttachment(attachments) || '';
    if (url && url !== this.selectedAttachmentUrl) {
      this.selectAttachment(url);
    }
  }

  /**
   * The attachment the order lines were parsed from, '' when unknown.
   *
   * WB-8267: the backend ALREADY answers this — `email.order_lines_document` (WB-7542), whose `url`
   * is byte-identical to its own `attachments[]` entry. Ask it first. On inbox orders it identifies
   * the file by real Unipile attachment id, which the filename comparison below cannot reproduce at
   * any level of normalisation: the stored attachment name and the name the AI reports as a line's
   * `_source` are written by different systems and regularly disagree.
   *
   * Matched back by path key rather than string equality, because presigned URLs are re-signed
   * between reads and the borrowed-attachments path (`withFallbackAttachments`) swaps the list out
   * from under a stale `order_lines_document` entirely.
   *
   * The filename resolver stays as the fallback — it is the only signal on prompt orders, on split
   * children previewing a parent's files, and on anything served before WB-7542.
   */
  private resolveSourceAttachment(attachments: string[]): string {
    const servedKey = attachmentPathKey(this.quotationSourceContent?.email?.order_lines_document?.url);
    const served = servedKey ? attachments.find((a) => attachmentPathKey(a) === servedKey) : undefined;
    return served ?? findSourceAttachment(attachments, this.orderSourceLines()) ?? '';
  }

  /**
   * WB-8267: the body is open exactly when no source document could be resolved — with nothing
   * trustworthy to preview, the email itself is where the order came from.
   *
   * One-shot per attachment list, and that is the whole point: resolution is re-attempted on every
   * store emission (it only latches once it SUCCEEDS), so re-deciding each time would spring the
   * body back open on an unresolved order every time the user collapsed it.
   */
  private applyBodyExpandDefault(): void {
    if (this.bodyDefaultApplied) {
      return;
    }
    this.bodyDefaultApplied = true;
    this.contentExpanded = !this.resolvedSourceAttachment;
  }

  /** Release a pinned doc highlight (WB-7483) — the edit ended, so hover drives the document again. */
  private unlockDocHighlight(): void {
    this.lockedLineKey = null;
    this.activeLineKey = null;
    this.activeField = null;
  }

  /**
   * Key of the line the document highlights: the pinned line while an alternatives edit is open
   * (WB-7483), otherwise the hovered one.
   */
  private get highlightedLineKey(): string | null {
    return this.lockedLineKey ?? this.activeLineKey;
  }

  /** Resolve the highlighted line (by stable key, never object identity — combinedLines hands out copies). */
  private get activeLine(): IParseProduct | null {
    const key = this.highlightedLineKey;
    if (!key) {
      return null;
    }
    return (
      this.products.find((p) => this.getRowKey(p) === key) ??
      this.unmatchedProducts.find((p) => this.getRowKey(p) === key) ??
      null
    );
  }

  /**
   * WB-7399: the overlays describe the document the lines were parsed from, so they must never be
   * painted over a supporting attachment. Permissive when unresolved — no signal keeps the
   * pre-WB-7399 behaviour rather than guessing.
   */
  get isSourceDocumentPreviewed(): boolean {
    const matched = this.resolvedSourceAttachment;
    return !matched || attachmentPathKey(matched) === attachmentPathKey(this.selectedAttachmentUrl);
  }

  /** Resolve the row-tier location for a line: explicit `row`, else the union-of-fields fallback. */
  private rowLocationOf(locations?: IFieldLocations): ISourceLocation | null {
    if (!locations) {
      return null;
    }
    return locations.row ?? deriveRowBox(locations);
  }

  /**
   * Document Coordinates: builds the previewer highlight from the active line — a light row tier
   * always (row box or derived), plus a strong field tier when a field cell is hovered (row + field).
   * While a line is pinned (WB-7483) the row tier is drawn in the stronger `locked` variant and the
   * field tier is skipped: there is no hovered cell behind an open editor, only the whole line.
   */
  get previewHighlight(): DocumentHighlight | null {
    if (!this.isSourceDocumentPreviewed) {
      return null;
    }
    const line = this.activeLine;
    const locations = line?.source_locations;
    if (!locations) {
      return null;
    }
    const isLocked = !!this.lockedLineKey;
    const boxes: HighlightBox[] = [];
    let page: number | undefined;

    const rowLoc = this.rowLocationOf(locations);
    if (rowLoc && rowLoc.kind === 'box') {
      rowLoc.boxes.forEach((b) => boxes.push({ ...b, variant: isLocked ? 'locked' : 'row' }));
      page = rowLoc.document_ref?.page;
    }

    if (this.activeField && !isLocked) {
      const fieldLoc = locations[this.activeField];
      if (fieldLoc && fieldLoc.kind === 'box') {
        fieldLoc.boxes.forEach((b) => boxes.push({ ...b, variant: 'field' }));
        page = page ?? fieldLoc.document_ref?.page;
      }
    }

    return boxes.length ? { boxes, page } : null;
  }

  /**
   * WB-7592: does the previewed attachment hold this line? Guards the two-workbooks-in-one-email
   * case, which `isSourceDocumentPreviewed` can't — it only picks the order's majority attachment.
   *
   * Suppresses ONLY on a positive conflict — the name matches a DIFFERENT attachment of this order.
   * Anything else is permissive, matching the order-level guard.
   *
   * Failing closed on a bare mismatch is wrong, because the emitter and the attachment store name
   * the same file differently and neither naming is ours: an upload index prefix (`1_order.xlsx` vs
   * `order.xlsx`), download-duplicate suffixes (`order (1).xlsx`), opaque proxy tokens with no name
   * at all. Each of those killed every highlight with nothing on screen to explain why.
   *
   * Deliberately NOT `line.source` — it also carries markers (`"combined"`, `"email_body"`) that
   * name no attachment and can't be told apart from a filename.
   */
  private lineHoldsPreviewedFile(loc: ISourceLocationCell): boolean {
    const named = loc.document_ref?.filename;
    if (!named || sourceNamesAttachment(named, this.selectedAttachmentUrl)) {
      return true;
    }
    const attachments = this.quotationSourceContent?.email?.attachments ?? [];
    return !attachments.some((url) => sourceNamesAttachment(named, url));
  }

  /**
   * The spreadsheet counterpart of `previewHighlight` (WB-7592) — same active line and tiers,
   * different substrate. Separate because a cell location has no box to hand the raster overlay,
   * and only one substrate can apply to a given document.
   */
  get previewCellHighlight(): DocumentCellHighlight | null {
    if (!this.isSourceDocumentPreviewed) {
      return null;
    }
    const line = this.activeLine;
    const locations = line?.source_locations;
    if (!line || !locations) {
      return null;
    }
    const isLocked = !!this.lockedLineKey;
    const ranges: DocumentCellHighlight['ranges'] = [];
    let sheet: string | undefined;

    const rowLoc = this.rowLocationOf(locations);
    if (rowLoc?.kind === 'cell' && this.lineHoldsPreviewedFile(rowLoc)) {
      ranges.push({ range: rowLoc.range, variant: isLocked ? 'locked' : 'row' });
      sheet = rowLoc.sheet;
    }

    if (this.activeField && !isLocked) {
      const fieldLoc = locations[this.activeField];
      if (fieldLoc?.kind === 'cell' && this.lineHoldsPreviewedFile(fieldLoc)) {
        ranges.push({ range: fieldLoc.range, variant: 'field' });
        sheet = sheet ?? fieldLoc.sheet;
      }
    }

    return ranges.length ? { sheet, ranges } : null;
  }

  /** The line the body should emphasize — pinned line while re-matching, else the hovered one. */
  get activeTextAnchorKey(): string | null {
    return this.highlightedLineKey;
  }

  /** True when the emphasized line is anchored in the body rather than on an attachment. */
  private activeLineHasTextAnchor(): boolean {
    const rowLoc = this.rowLocationOf(this.activeLine?.source_locations);
    return rowLoc?.kind === 'text_range' && !!rowLoc.quote;
  }

  /**
   * Open the body block when the active line is anchored in it — a highlight painted into the
   * collapsed `height: 0; overflow: hidden` box reads exactly like no anchor at all, and the body
   * starts collapsed on any order that has attachments.
   *
   * Sticky, like `targetPage` and `selectedSheetIndex` on the other two paths: never re-collapses
   * on hover-out, so sliding down the list can't thrash the animation.
   */
  private revealBodyForTextAnchor(): void {
    if (!this.contentExpanded && this.activeLineHasTextAnchor()) {
      this.contentExpanded = true;
    }
  }

  /**
   * Reverse hover from the email body (WB-7625) — a body anchor was hovered, so emphasize the
   * matching list row. The text sibling of `onDocLineHover`, and separate from it for one reason:
   * that handler drops keyed hovers unless `isSourceDocumentPreviewed`, which asks which
   * ATTACHMENT is on screen. The body is not an attachment, so applying that guard here would kill
   * every body hover on an order that merely also has attachments.
   *
   * Still ignored while a line is pinned (WB-7483): the marks stay live in the body, so without
   * this a stray mouse move over another anchor would steal the highlight mid-edit.
   */
  onBodyAnchorHover(key: string | null): void {
    if (this.lockedLineKey) return;
    this.activeLineKey = key;
    this.activeField = null;
    if (key) {
      this.scrollActiveRowIntoView(key);
    }
  }

  /**
   * The body's expand animation is 300ms, and scrolling into a box that is still collapsing does
   * nothing — so the highlight is scrolled into view from the animation's own `done` event rather
   * than a guessed delay.
   */
  onContentExpandDone(): void {
    this.bodyHighlight?.scrollAnchorIntoView();
  }

  /** Hovering a field cell highlights the row (light) + that field (strong). */
  onFieldHover(product: IParseProduct, field: SourceLocationField): void {
    if (this.lockedLineKey) return;
    this.activeLineKey = this.getRowKey(product);
    this.activeField = field;
    this.revealBodyForTextAnchor();
  }

  /** Leaving a field cell drops only the field tier; the row tier is owned by the <tr> hover. */
  onFieldHoverEnd(): void {
    if (this.lockedLineKey) return;
    this.activeField = null;
  }

  /** Hovering anywhere on a row highlights the full line (row tier only). */
  onRowHover(product: IParseProduct): void {
    if (this.lockedLineKey) return;
    this.activeLineKey = this.getRowKey(product);
    this.revealBodyForTextAnchor();
  }

  onRowHoverEnd(): void {
    if (this.lockedLineKey) return;
    this.activeLineKey = null;
    this.activeField = null;
  }

  /**
   * Reverse hover (FE-7): a doc line region was hovered → emphasize the matching list row (rows only).
   * Ignored while a line is pinned (WB-7483) — the hotspots stay live under the document, so without
   * this a stray mouse move over another doc line would steal the highlight mid-edit.
   */
  onDocLineHover(key: string | null): void {
    if (this.lockedLineKey) return;
    // Ignore KEYED hovers while the overlays are suppressed, but always let `null` through so an
    // existing emphasis can still clear: the previewer drops `pdfPageHotspots` inside a rAF, so the
    // previous document's hotspot layer survives a frame after `data` changes.
    if (key && !this.isSourceDocumentPreviewed) return;
    this.activeLineKey = key;
    this.activeField = null;
    if (key) {
      this.scrollActiveRowIntoView(key);
    }
  }

  isRowActive(product: IParseProduct): boolean {
    return !!this.activeLineKey && this.getRowKey(product) === this.activeLineKey;
  }

  /** Public, template-safe accessor for the stable row key (used for the data-row-key attribute). */
  rowKeyOf(product: IParseProduct): string {
    return this.getRowKey(product);
  }

  /** Scroll the matching list row into view when it's off-screen (doc→list reverse hover). */
  private scrollActiveRowIntoView(key: string): void {
    const host = this.el?.nativeElement;
    if (!host) {
      return;
    }
    const row = host.querySelector(`[data-row-key="${(window as any).CSS?.escape ? CSS.escape(key) : key}"]`) as HTMLElement | null;
    row?.scrollIntoView({ block: 'nearest' });
  }

  /** Cached doc→list regions: one per line (products + unmatched) that has an explicit or derivable row box. */
  private _lineRegionsCache: {
    products: IParseProduct[];
    unmatched: IParseProduct[];
    productsLen: number;
    unmatchedLen: number;
    regions: DocumentLineRegion[];
  } | null = null;

  /** Stable empty result for the suppressed case — see `lineRegions`. */
  private static readonly NO_LINE_REGIONS: DocumentLineRegion[] = [];

  get lineRegions(): DocumentLineRegion[] {
    // Guarded BEFORE the cache, whose key is the line arrays only. Returning the SAME array every
    // call is load-bearing: a fresh [] per CD cycle would re-fire the previewer's ngOnChanges.
    if (!this.isSourceDocumentPreviewed) {
      return SideBySideCorrectionPanelComponent.NO_LINE_REGIONS;
    }
    const cache = this._lineRegionsCache;
    if (
      cache &&
      cache.products === this.products &&
      cache.unmatched === this.unmatchedProducts &&
      cache.productsLen === this.products.length &&
      cache.unmatchedLen === (this.unmatchedProducts?.length ?? 0)
    ) {
      return cache.regions;
    }
    const regions = this.buildLineRegions();
    this._lineRegionsCache = {
      products: this.products,
      unmatched: this.unmatchedProducts,
      productsLen: this.products.length,
      unmatchedLen: this.unmatchedProducts?.length ?? 0,
      regions,
    };
    return regions;
  }

  private buildLineRegions(): DocumentLineRegion[] {
    const lines = [...(this.products || []), ...(this.unmatchedProducts || [])];
    const regions: DocumentLineRegion[] = [];
    lines.forEach((line) => {
      const rowLoc = this.rowLocationOf(line.source_locations);
      if (rowLoc && rowLoc.kind === 'box' && rowLoc.boxes.length) {
        regions.push({ key: this.getRowKey(line), box: rowLoc.boxes[0], page: rowLoc.document_ref?.page });
      }
    });
    // Enlarge the (invisible) doc→list hover targets so they're easy to hit: expand each strip
    // vertically toward the midpoint between its neighbour rows ON THE SAME PAGE. The strips then tile
    // the column, overlap-free by construction (they meet at the midpoint, never cross) — safe even on
    // dense pages with thin lines (tighter rows → smaller strips, never onto a neighbour). This changes
    // ONLY the hover target: the visible highlight uses `previewHighlight` (a separate, unchanged box),
    // and `expandRowBoxesToMidpoints` returns new boxes so the shared source box is never mutated.
    const byPage = new Map<number, DocumentLineRegion[]>();
    regions.forEach((r) => {
      const page = r.page ?? 1;
      const bucket = byPage.get(page);
      if (bucket) { bucket.push(r); } else { byPage.set(page, [r]); }
    });
    const expanded: DocumentLineRegion[] = [];
    byPage.forEach((group) => {
      const grown = expandRowBoxesToMidpoints(group.map((r) => r.box));
      group.forEach((r, i) => expanded.push({ ...r, box: grown[i] }));
    });
    return expanded.sort((a, b) => a.key.localeCompare(b.key));
  }

  /**
   * Cached doc→list regions for the spreadsheet path (WB-7592). Unlike `_lineRegionsCache` the key
   * carries the selected attachment: the builder filters by which workbook holds each line, so the
   * same line arrays yield different regions once the attachment changes.
   */
  private _cellRegionsCache: {
    products: IParseProduct[];
    unmatched: IParseProduct[];
    productsLen: number;
    unmatchedLen: number;
    attachment: string;
    regions: DocumentCellRegion[];
  } | null = null;

  /** Stable empty result for the suppressed case — see `lineRegions`. */
  private static readonly NO_CELL_REGIONS: DocumentCellRegion[] = [];

  get cellRegions(): DocumentCellRegion[] {
    // Same discipline as `lineRegions`: guard before the cache, and return the SAME array each call
    // so a CD cycle doesn't re-fire the previewer's ngOnChanges.
    if (!this.isSourceDocumentPreviewed) {
      return SideBySideCorrectionPanelComponent.NO_CELL_REGIONS;
    }
    const cache = this._cellRegionsCache;
    if (
      cache &&
      cache.products === this.products &&
      cache.unmatched === this.unmatchedProducts &&
      cache.productsLen === this.products.length &&
      cache.unmatchedLen === (this.unmatchedProducts?.length ?? 0) &&
      cache.attachment === this.selectedAttachmentUrl
    ) {
      return cache.regions;
    }
    const regions = this.buildCellRegions();
    this._cellRegionsCache = {
      products: this.products,
      unmatched: this.unmatchedProducts,
      productsLen: this.products.length,
      unmatchedLen: this.unmatchedProducts?.length ?? 0,
      attachment: this.selectedAttachmentUrl,
      regions,
    };
    return regions;
  }

  private buildCellRegions(): DocumentCellRegion[] {
    const lines = [...(this.products || []), ...(this.unmatchedProducts || [])];
    const regions: DocumentCellRegion[] = [];
    lines.forEach((line) => {
      const rowLoc = this.rowLocationOf(line.source_locations);
      if (rowLoc?.kind !== 'cell' || !this.lineHoldsPreviewedFile(rowLoc)) {
        return;
      }
      // `range` is the source of truth, `row` only its mirror — never the other way round.
      const span = decodeRowSpan(rowLoc.range);
      const absRow = span ? span.row + 1 : rowLoc.row;
      if (absRow === undefined) {
        return;
      }
      regions.push({ key: this.getRowKey(line), sheet: rowLoc.sheet, row: absRow });
    });
    return regions;
  }

  /** Cached body anchors: one per line whose row location is a resolvable email-body quote. */
  private _textAnchorRegionsCache: {
    products: IParseProduct[];
    unmatched: IParseProduct[];
    productsLen: number;
    unmatchedLen: number;
    regions: EmailBodyAnchorRegion[];
  } | null = null;

  /** Stable empty result — see `textAnchorRegions`. */
  private static readonly NO_TEXT_ANCHORS: EmailBodyAnchorRegion[] = [];

  /**
   * The email-body counterpart of `lineRegions` / `cellRegions` (WB-7625). EVERY anchored line, not
   * just the active one: each needs its own hit target in the body for the reverse direction.
   *
   * Deliberately NOT gated on `isSourceDocumentPreviewed` like both siblings. That guard asks which
   * ATTACHMENT is on screen, and the body is not an attachment — `document_ref` here is only
   * `{ source: 'email_body' }`, so there is nothing to reconcile and the sole gate is whether the
   * quote resolves, which the renderer decides rather than this getter.
   *
   * Returning the SAME array when nothing changed is load-bearing, as for the siblings: the
   * directive keys its re-resolution on the anchor set, and re-resolving rewrites body DOM.
   */
  get textAnchorRegions(): EmailBodyAnchorRegion[] {
    const cache = this._textAnchorRegionsCache;
    if (
      cache &&
      cache.products === this.products &&
      cache.unmatched === this.unmatchedProducts &&
      cache.productsLen === this.products.length &&
      cache.unmatchedLen === (this.unmatchedProducts?.length ?? 0)
    ) {
      return cache.regions;
    }
    const regions = this.buildTextAnchorRegions();
    this._textAnchorRegionsCache = {
      products: this.products,
      unmatched: this.unmatchedProducts,
      productsLen: this.products.length,
      unmatchedLen: this.unmatchedProducts?.length ?? 0,
      regions: regions.length ? regions : SideBySideCorrectionPanelComponent.NO_TEXT_ANCHORS,
    };
    return this._textAnchorRegionsCache.regions;
  }

  private buildTextAnchorRegions(): EmailBodyAnchorRegion[] {
    const lines = [...(this.products || []), ...(this.unmatchedProducts || [])];
    const regions: EmailBodyAnchorRegion[] = [];
    lines.forEach((line) => {
      const rowLoc = this.rowLocationOf(line.source_locations);
      if (rowLoc?.kind !== 'text_range' || !rowLoc.quote) {
        return;
      }
      regions.push({ key: this.getRowKey(line), quote: rowLoc.quote, occurrence: rowLoc.occurrence });
    });
    return regions;
  }

  isAttachmentSelected(attachmentUrl: string): boolean {
    return this.selectedAttachmentUrl === attachmentUrl;
  }

  getAttachmentName(attachmentUrl: string): string {
    return attachmentFileName(attachmentUrl);
  }

  close(force = false): void {
    if (!force && this.hasUnsavedChanges()) {
      const confirmDialogRef = this.dialog.open(ConfirmationPopUpComponent, {
        data: {
          title: this.translateService.instant('quotations_and_orders.unsaved_changes_title'),
          text: this.translateService.instant('quotations_and_orders.unsaved_changes_confirm_message'),
          icon: '../../../assets/icones/alert-circle.svg',
          confirm_text: this.translateService.instant('quotations_and_orders.discard_changes'),
          confirm_class: 'btn-warning',
          // show_third_btn: true,
          third_btn_text: this.translateService.instant('quotations_and_orders.save_and_close'),
          third_btn_class: 'btn-primary',
        }
      });
      confirmDialogRef.afterClosed().subscribe((result: boolean | string) => {
        if (result === true) {
          this.animateClose();
        } else if (result === 'third') {
          this.save();
        }
      });
      return;
    }
    this.animateClose();
  }

  /**
   * Slide the panel out to the right (mirror of the slide-in) and close the
   * dialog once the animation finishes. All close paths funnel through here.
   */
  private animateClose(result?: unknown): void {
    if (this.isClosing) {
      return;
    }
    this.isClosing = true;
    // WB-7569 — a split has no close path of its own: the user splits, keeps
    // working, then closes through any of the ordinary routes (X, Escape,
    // backdrop). Fill in the result here so the Smart Inbox timeline still
    // refetches instead of re-rendering the pre-split product list. An explicit
    // result wins — approve / cancel / archive / delete already imply mutation.
    const closeResult = result ?? (this.didSplitOrder ? SIDE_BY_SIDE_RESULT_SPLIT : undefined);
    this.dialogRef.addPanelClass('side-panel-closing');
    setTimeout(() => this.dialogRef.close(closeResult), SIDE_PANEL_ANIMATION_MS);
  }

  /**
   * Public, template-safe view of the dirty state (WB-7478): drives the unsaved
   * changes indicator in the header and disables Approve Order until the edits are
   * saved.
   *
   * Memoised because `hasLineChanges()` rebuilds and stringifies every order line,
   * and the template reads this several times per change-detection pass (the
   * indicator's `ngIf`, its tooltip, the Approve button's `disabled`). The cache is
   * cleared in `ngDoCheck`, which Angular runs once per pass before evaluating the
   * template — so reads within a pass share one computation and the value can never
   * be stale. Do NOT invalidate this by scheduling a microtask: the zone would see
   * pending work after every pass and loop change detection indefinitely.
   */
  get isDirty(): boolean {
    if (this.dirtyCache === null) {
      this.dirtyCache = this.hasUnsavedChanges();
    }
    return this.dirtyCache;
  }

  /**
   * Releases the `isDirty` memo once per change-detection pass. Deliberately the
   * only invalidation point — see `isDirty`.
   */
  ngDoCheck(): void {
    this.dirtyCache = null;
  }

  /**
   * Drops the `isDirty` memo immediately, for code that rebaselines mid-tick.
   *
   * `ngDoCheck` alone is too late for anything reading `isDirty` synchronously
   * after a rebaseline: NgRx action handlers run inside the effect, before the
   * next change-detection pass, so they would see the pre-save value. That is
   * what silently blocked the split proposal on a first company assignment
   * (WB-7569) — the panel was dirty a moment earlier, and the guard believed it.
   */
  private invalidateDirtyCache(): void {
    this.dirtyCache = null;
  }

  private hasUnsavedChanges(): boolean {
    return this.hasLineChanges() || this.hasDetailsChanges();
  }

  private hasLineChanges(): boolean {
    if ((this.newProducts || []).length > 0) return true;
    if ((this.removedProducts || []).length > 0) return true;
    if ((this.removedUnmatchedOrderLineIds || []).length > 0) return true;
    if ((this.matchUnmatched || []).length > 0) return true;
    if ((this.ignoreUnmatched || []).length > 0) return true;
    for (const p of this.products || []) {
      const line = this.toUpdateLine(p);
      if (!line) continue;
      const initial = this.initialUpdateLineSignatures.get(line.id);
      if (initial !== JSON.stringify(line)) return true;
    }
    return false;
  }

  private hasDetailsChanges(): boolean {
    return this.buildDetailsSignature() !== this.initialDetailsSignature;
  }

  private buildDetailsSignature(): string {
    return JSON.stringify({
      partnerId: this.detailsDraft.partnerId ?? null,
      partnerCompanyId: this.detailsDraft.partnerCompanyId ?? null,
      customerPoNumber: this.detailsDraft.customerPoNumber ?? '',
      quoteId: this.detailsDraft.quoteId ?? '',
      shippingDate: this.detailsDraft.shippingDate ?? '',
      ownerId: this.detailsDraft.ownerId ?? null,
      comment: this.detailsDraft.comment ?? '',
      paymentTermsId: this.detailsDraft.paymentTermsId ?? null,
    });
  }

  private buildDetailsPayload(): IUpdateQuotationDetails {
    const payload: IUpdateQuotationDetails = {};
    // Baselined against the SAME location the block drafts from, or a divergent
    // order (billing ≠ shipping) would diff the drafted shipping location
    // against the billing one and send a `partner_id` on every unrelated save.
    const initialPartnerId = this.shippingLocationOf(this.quotation)?.id;
    const initialPartnerCompanyId = this.quotation?.order_company?.id ?? this.quotation?.location?.id_company;
    const initialPoNumber = this.quotation?.customer_po_number ?? undefined;
    const initialQuoteId = this.quotation?.quote_id ?? undefined;
    const initialShippingDate = this.quotation?.shipping_date ?? undefined;

    if (this.detailsDraft.partnerId !== undefined && this.detailsDraft.partnerId !== initialPartnerId) {
      payload.partner_id = this.detailsDraft.partnerId;
    }
    if (this.detailsDraft.partnerCompanyId !== undefined && this.detailsDraft.partnerCompanyId !== initialPartnerCompanyId) {
      payload.id_company = this.detailsDraft.partnerCompanyId;
    }
    if ((this.detailsDraft.customerPoNumber ?? '') !== (initialPoNumber ?? '')) {
      payload.customer_po_number = this.detailsDraft.customerPoNumber ?? '';
    }
    if ((this.detailsDraft.quoteId ?? '') !== (initialQuoteId ?? '')) {
      payload.quote_id = this.detailsDraft.quoteId ?? '';
    }
    if ((this.detailsDraft.shippingDate ?? '') !== (initialShippingDate ?? '')) {
      payload.shipping_date = this.detailsDraft.shippingDate ?? '';
    }
    const initialOwnerId = this.quotation?.owner?.id ?? undefined;
    if ((this.detailsDraft.ownerId ?? null) !== (initialOwnerId ?? null)) {
      payload.owner_id = this.detailsDraft.ownerId;
    }
    const initialComment = this.quotation?.comment ?? '';
    if ((this.detailsDraft.comment ?? '') !== initialComment) {
      payload.comment = this.detailsDraft.comment ?? '';
    }
    const initialPaymentTermsId = this.quotation?.payment_terms?.id ?? null;
    if ((this.detailsDraft.paymentTermsId ?? null) !== initialPaymentTermsId) {
      payload.payment_terms = this.detailsDraft.paymentTermsId ?? null;
    }
    return payload;
  }

  // ── Configurable detail blocks (WB-7463) ──────────────────────────────────

  /** Recompute every configurable block and re-apply the saved preferences. */
  private buildDetailFields(): void {
    const fields = this.orderDetailFields.build({
      location: this.quotation?.location,
      // Drafted like every other details edit (WB-8331), so the whole Shipping
      // block follows a manual pick instead of waiting for the save.
      shippingLocation: this.detailsDraft.shippingLocation,
      orderCompany: this.quotation?.order_company,
      // Payment terms are drafted here like every other details edit, so the
      // row reflects the pending choice rather than what is saved.
      paymentTerms: this.detailsDraft.paymentTermsId
        ? ({ id: this.detailsDraft.paymentTermsId, name: this.detailsDraft.paymentTermsName } as IPayment_term)
        : null,
      paymentTermOptions: this.paymentTermOptions,
      customerPoNumber: this.detailsDraft.customerPoNumber,
      quoteId: this.detailsDraft.quoteId,
      shippingDate: this.detailsDraft.shippingDate,
      comment: this.detailsDraft.comment,
      objectCustomFields: this.objectCustomFields,
      currentLanguage: this.currentLanguage,
      hiddenOrderFields: this.hiddenOrderFields,
      hasFreeShipping: false,
    });

    this.fieldGroups = fields.groups;
    this.customerFields = fields.customer;
    this.shippingFields = fields.shipping;
    this.orderReferenceFields = fields.references;
    this.orderCustomFieldRows = fields.customFields;
    // Cached rather than computed in the template: a new array on every change
    // detection run would re-create the tags each tick.
    // WB-7836 (review follow-up): the tax codes shown in the Shipping block
    // are the shipping location's own, not the Customer/billing location's.
    // WB-8331: read the drafted location, so they follow a manual pick.
    this.taxCodeTags = locationCodeTags(this.detailsDraft.shippingLocation);
  }

  /** Rule behind a split, shown in the info popover on the Details block. */
  segregationRuleSummary(info: ISegregationInfo | ISegregationSplit): string {
    return this.orderDetailFields.segregationRuleSummary(info);
  }

  /** Past the inline threshold the counter opens the full list, as on the detail page. */
  openLinkedOrders(): void {
    const splits = this.quotation?.segregation_splits ?? [];
    if (!splits.length) return;
    this.dialog.open(LinkedOrdersModalComponent, {
      data: { orderName: this.quotation?.name ?? '', splits },
      maxWidth: '95vw',
      autoFocus: 'dialog',
    });
  }

  /** One block's visibility/order changed in the shared settings drawer. */
  onFieldGroupChange(change: IDetailFieldGroupChange): void {
    this.orderDetailFields.saveGroup(change, this.fieldGroups);
    this.buildDetailFields();
  }

  /** A `modal` row asked for its editor. Both open the inline selector here. */
  onDetailFieldEdit(field: IDetailField): void {
    if (field.key === 'company') {
      this.openCompanyLocationEditor('company');
    } else if (field.key === 'location') {
      this.openCompanyLocationEditor('location');
    }
  }

  /**
   * An `inline` row was saved. Unlike the order detail page, edits are buffered
   * into `detailsDraft` and persisted by the panel's own Save — except custom
   * fields, which have no draft slot and go straight through.
   */
  onDetailFieldValueChange(change: IDetailFieldChange): void {
    if (change.key.startsWith('order_custom_')) {
      this.saveInlineCustomField(change.key.replace('order_custom_', ''), change.value);
      return;
    }

    switch (change.key) {
      case 'payment_terms': {
        const term = change.value === null
          ? null
          : this.paymentTermOptions.find((option) => option.id === change.value);
        if (term === undefined) return;
        this.detailsDraft.paymentTermsId = term?.id ?? null;
        this.detailsDraft.paymentTermsName = term?.name;
        break;
      }
      case 'customer_po_number':
        this.detailsDraft.customerPoNumber = (change.value as string) ?? '';
        break;
      case 'quote_id':
        this.detailsDraft.quoteId = (change.value as string) ?? '';
        break;
      case 'shipping_date':
        this.detailsDraft.shippingDate = (change.value as string) ?? '';
        break;
      case 'internal_note':
        this.detailsDraft.comment = (change.value as string) ?? '';
        break;
    }
    this.buildDetailFields();
  }

  /** Persist one custom field without disturbing the others. */
  private saveInlineCustomField(technicalName: string, value: string | number | null): void {
    const definition = this.objectCustomFields?.definitions?.find(
      (item) => item.technical_name === technicalName
    );
    // The boolean picker round-trips 'true'/'false' strings; store real booleans.
    const stored =
      definition?.field_type === CustomFieldTypes.BOOLEAN && value !== null
        ? value === 'true'
        : value;

    const values = {
      ...(this.objectCustomFields?.values ?? {}),
      [technicalName]: stored as string,
    };
    this.objectCustomFields = this.objectCustomFields
      ? { ...this.objectCustomFields, values }
      : this.objectCustomFields;
    this.saveOrderCustomFields(values);
    this.buildDetailFields();
  }

  /**
   * True when at least one order custom field is of a type the inline editor
   * cannot express, so the dialog is still worth offering.
   */
  hasDialogOnlyCustomFields(): boolean {
    return this.orderCustomFieldRows.some((field) => field.mode === 'readonly');
  }

  private toUpdateLine(product: IParseProduct): {
    id: number;
    product_id: number;
    quantity: number;
    handling_unit_id?: number;
    quantity_handling_unit?: number;
    matched?: boolean;
    delivery_date?: string;
    is_gift?: boolean;
    final_price?: number;
    price_type?: PriceSourceType;
    notes?: string;
    correction_intent?: CorrectionIntent;
    amtw_code?: string;
  } | null {
    const id = product?.order_line_id;
    if (id === null || id === undefined) return null;

    const product_id = (product.product_id ?? product.id) as number | undefined;
    if (!product_id) return null;

    const perLineIntent = product._correctionIntent;
    const perLineAmtwCode = product._amtwCode ?? undefined;

    return {
      id,
      product_id,
      quantity: Number(product.quantity) || 0,
      handling_unit_id: product.handling_unit_id ?? undefined,
      quantity_handling_unit: product.quantity_handling_unit ?? undefined,
      matched: product.matched ?? false,
      delivery_date: product.delivery_date ?? undefined,
      is_gift: product.is_gift ?? false,
      final_price: product.final_price ?? undefined,
      price_type: product.price_type ?? undefined,
      // Send notes whenever set or being cleared (''); JSON.stringify drops it when null/undefined,
      // so the change-signature diff and the backend 'notes' in item guard both behave correctly.
      notes: product.notes ?? undefined,
      ...(perLineIntent ? { correction_intent: perLineIntent } : {}),
      ...(perLineAmtwCode ? { amtw_code: perLineAmtwCode } : {}),
    };
  }

  private toAddLine(product: IParseProduct): {
    product_id: number;
    quantity: number;
    handling_unit_id?: number;
    quantity_handling_unit?: number;
    added_manually?: boolean;
    delivery_date?: string;
    is_gift?: boolean;
    final_price?: number;
    price_type?: PriceSourceType;
  } | null {
    const product_id = (product.id ?? product.product_id) as number | undefined;
    if (!product_id) return null;

    return {
      product_id,
      quantity: Number(product.quantity) || 0,
      handling_unit_id: product.handling_unit_id ?? undefined,
      quantity_handling_unit: product.quantity_handling_unit ?? undefined,
      added_manually: true,
      delivery_date: product.delivery_date ?? undefined,
      is_gift: product.is_gift ?? false,
      final_price: product.final_price ?? undefined,
      price_type: product.price_type ?? undefined,
    };
  }

  isSkuMatchHighlight(product: IParseProduct): boolean {
    return (product.ai_match_method || '').toLowerCase() === 'exact_code'
      && (product.ai_match_field || '').toLowerCase() === 'sku';
  }

  private isManualPick(product: IParseProduct): boolean {
    return !!(product.matched || product.added_manually);
  }

  getInlineMatchCode(product: IParseProduct): string | null {
    if (this.isManualPick(product)) return null;
    const method = (product.ai_match_method || '').toLowerCase();
    const value = (product.ai_match_value || '').trim();
    if (!value) return null;
    if (method === 'exact_alias') return value;
    if (method === 'exact_code' && (product.ai_match_field || '').toLowerCase() !== 'sku') return value;
    if ((method === 'preferred' || method === 'preferred_global') && /^\d+$/.test(value)) {
      // Chip is scope-free; the sublabel carries per-customer vs global.
      return this.translateService.instant('quotations_and_orders.match_method.frequency_inline', { count: value });
    }
    return null;
  }

  getSemanticParsedCodes(product: IParseProduct): string[] {
    const method = (product.ai_match_method || '').toLowerCase();
    if (method === 'null') {
      // WB-7907: a line manually matched from a previously AI-unmatched row
      // carries no AI match reasoning to go stale -- ai_match_value/field
      // are blank by design (never an AI match to begin with), and
      // ai_extracted_codes is the document's own text for this row, not
      // tied to whichever product got picked. Exempt it from the WB-7829
      // manual-pick gate below, which exists to stop a *re-matched*
      // AI-matched line from crediting its old match reasoning to the
      // newly chosen product.
      return (product.ai_extracted_codes || '')
        .split(',')
        .map(c => c.trim())
        .filter(Boolean);
    }
    if (this.isManualPick(product)) return [];
    if (method !== 'hybrid_reranked') {
      return [];
    }
    return (product.ai_extracted_codes || '')
      .split(',')
      .map(c => c.trim())
      .filter(Boolean);
  }

  private normalizeExtractedNotes(
    notes: any
  ): { extracted: { category: string; text: string }[]; summary: string } | null {
    if (!notes) return null;
    const extracted = (notes.extracted || []).map((item: any) =>
      typeof item === 'string' ? { category: '', text: item } : item
    );
    return { extracted, summary: notes.summary || '' };
  }

  onExtractedNotesSave(extracted: IExtractedNote[]): void {
    if (this.extractedNotes) {
      this.extractedNotes = { ...this.extractedNotes, extracted };
    }
    if (this.quotation?.id != null) {
      this.store.dispatch(UpdateAiNotes({ id: this.quotation.id, payload: { notes: extracted } }));
    }
  }


}
